const getInTrailPoisSvg = (hsl1, hsl2, status, forGpsTracking) => {
  // Default SVG (status is empty)
  if (!status) {
    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
        <svg height="${forGpsTracking ? "15px" : "20px"}" width="${
        forGpsTracking ? "15px" : "20px"
      }" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.00 512.00" xml:space="preserve" fill="#000000">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <circle style="fill:${hsl2};" cx="256" cy="256" r="256"></circle>
            <path style="fill:${hsl1};" d="M256,0v512c141.385,0,256-114.615,256-256S397.385,0,256,0z"></path>
            <path style="fill:#F2F2F4;" d="M256,393.143c-75.621,0-137.143-61.522-137.143-137.143S180.379,118.857,256,118.857 S393.143,180.379,393.143,256S331.621,393.143,256,393.143z M256,173.714c-45.372,0-82.286,36.913-82.286,82.286 s36.913,82.286,82.286,82.286s82.286-36.913,82.286-82.286S301.374,173.714,256,173.714z"></path>
            <path style="fill:#DFDFE1;" d="M256,118.857v54.857c45.374,0,82.286,36.913,82.286,82.286S301.374,338.286,256,338.286v54.857 c75.621,0,137.143-61.522,137.143-137.143S331.621,118.857,256,118.857z"></path>
          </g>
        </svg>
      `)}`,
    };
  }

  // SVG for "DisqualifyOverSpeed" status
  if (status === "DisqualifyOverSpeed") {
    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
        <svg height="32px" width="32px" viewBox="0 0 576 576" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000">
          <!-- Outer Yellow Stroke -->
          <circle cx="288" cy="288" r="280" fill="none" stroke="black" stroke-width="20" />

          <!-- Middle Blue Stroke -->
          <circle cx="288" cy="288" r="240" fill="none" stroke="black" stroke-width="20" />

          <!-- Inner SVG -->
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier" transform="translate(96, 96) scale(0.75)">
            <circle style="fill:${hsl2};" cx="256" cy="256" r="256"></circle>
            <path style="fill:${hsl1};" d="M256,0v512c141.385,0,256-114.615,256-256S397.385,0,256,0z"></path>
            <path style="fill:#F2F2F4;" d="M256,393.143c-75.621,0-137.143-61.522-137.143-137.143S180.379,118.857,256,118.857 S393.143,180.379,393.143,256S331.621,393.143,256,393.143z M256,173.714c-45.372,0-82.286,36.913-82.286,82.286 s36.913,82.286,82.286,82.286s82.286-36.913,82.286-82.286S301.374,173.714,256,173.714z"></path>
            <path style="fill:#DFDFE1;" d="M256,118.857v54.857c45.374,0,82.286,36.913,82.286,82.286S301.374,338.286,256,338.286v54.857 c75.621,0,137.143-61.522,137.143-137.143S331.621,118.857,256,118.857z"></path>
          </g>
        </svg>
      `)}`,
    };
  }

  // SVG for "OverSpeed" status
  if (status === "OverSpeed") {
    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
        <svg height="32px" width="32px" viewBox="0 0 570 570" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000">
          <!-- Middle Blue Stroke -->
          <circle cx="288" cy="288" r="240" fill="none" stroke="black" stroke-width="20" />

          <!-- Inner SVG -->
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier" transform="translate(96, 96) scale(0.75)">
            <circle style="fill:${hsl2};" cx="256" cy="256" r="256"></circle>
            <path style="fill:${hsl1};" d="M256,0v512c141.385,0,256-114.615,256-256S397.385,0,256,0z"></path>
            <path style="fill:#F2F2F4;" d="M256,393.143c-75.621,0-137.143-61.522-137.143-137.143S180.379,118.857,256,118.857 S393.143,180.379,393.143,256S331.621,393.143,256,393.143z M256,173.714c-45.372,0-82.286,36.913-82.286,82.286 s36.913,82.286,82.286,82.286s82.286-36.913,82.286-82.286S301.374,173.714,256,173.714z"></path>
            <path style="fill:#DFDFE1;" d="M256,118.857v54.857c45.374,0,82.286,36.913,82.286,82.286S301.374,338.286,256,338.286v54.857 c75.621,0,137.143-61.522,137.143-137.143S331.621,118.857,256,118.857z"></path>
          </g>
        </svg>
      `)}`,
    };
  }
};

const getTeamNumberSvg = (teamNumber, color = "#000000") => {
  const svg = `
      <svg fill="${color}" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" width="50px" height="50px">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M956.952 0c-362.4 0-657 294.6-657 656.88 0 180.6 80.28 347.88 245.4 511.56 239.76 237.96 351.6 457.68 351.6 691.56v60h120v-60c0-232.8 110.28-446.16 357.6-691.44 165.12-163.8 245.4-331.08 245.4-511.68 0-362.28-294.6-656.88-663-656.88" fill-rule="evenodd"></path>
          <text x="960" y="700" text-anchor="middle" font-size="600" fill="#FFFFFF" font-family="Arial" dy=".3em">${teamNumber}</text>
        </g>
      </svg>
    `;

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
  };
};

const getLocationEnableDisableIcon = (isEnabled) => {
  if (isEnabled) {
    return (
      <svg
        width="25px"
        height="25px"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="m 8 0 c -3.3125 0 -6 2.6875 -6 6 c 0.007812 0.710938 0.136719 1.414062 0.386719 2.078125 l -0.015625 -0.003906 c 0.636718 1.988281 3.78125 5.082031 5.625 6.929687 h 0.003906 v -0.003906 c 1.507812 -1.507812 3.878906 -3.925781 5.046875 -5.753906 c 0.261719 -0.414063 0.46875 -0.808594 0.585937 -1.171875 l -0.019531 0.003906 c 0.25 -0.664063 0.382813 -1.367187 0.386719 -2.078125 c 0 -3.3125 -2.683594 -6 -6 -6 z m 0 3.691406 c 1.273438 0 2.308594 1.035156 2.308594 2.308594 s -1.035156 2.308594 -2.308594 2.308594 c -1.273438 -0.003906 -2.304688 -1.035156 -2.304688 -2.308594 c -0.003906 -1.273438 1.03125 -2.304688 2.304688 -2.308594 z m 0 0"
            fill="#2e3436"
          ></path>
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        width="25px"
        height="25px"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="m 8 0 c -1.894531 0 -3.582031 0.882812 -4.679688 2.257812 l -1.789062 -1.789062 l -1.0625 1.0625 l 14 14 l 1.0625 -1.0625 l -3.652344 -3.652344 c 0.449219 -0.546875 0.855469 -1.082031 1.167969 -1.570312 c 0.261719 -0.414063 0.46875 -0.808594 0.585937 -1.171875 l -0.019531 0.003906 c 0.25 -0.664063 0.382813 -1.367187 0.386719 -2.078125 c 0.003906 -3.3125 -2.6875 -6 -6 -6 z m 0 3.695312 c 1.273438 -0.003906 2.308594 1.03125 2.308594 2.304688 c 0 0.878906 -0.492188 1.640625 -1.214844 2.03125 l -3.125 -3.125 c 0.390625 -0.722656 1.152344 -1.210938 2.03125 -1.210938 z m -5.9375 1.429688 c -0.039062 0.289062 -0.0625 0.578125 -0.0625 0.875 c 0.003906 0.710938 0.136719 1.414062 0.386719 2.082031 l -0.015625 -0.007812 c 0.636718 1.988281 3.78125 5.082031 5.628906 6.925781 v 0.003906 v -0.003906 c 0.5625 -0.5625 1.25 -1.253906 1.945312 -1.992188 z m 0 0"
            fill="#2e3436"
          ></path>
        </g>
      </svg>
    );
  }
};

const NotificationBellSvg = () => (
  <svg
    height="25px"
    width="25px"
    version="1.1"
    id="_x34_"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g>
        <path
          style={{ fill: "#F8CC6D" }}
          d="M453.481,402.747c-28.353-17.478-41.329-72.613-41.329-90.987v-77.245 
               c0-84.141-60.354-154.138-140.122-169.171c2.114-2.739,3.914-5.743,5.283-8.997c2.064-4.853,3.197-10.223,3.197-15.786 
               c0.007-8.359-2.559-16.23-6.932-22.682c-4.373-6.474-10.539-11.592-17.829-14.682C250.89,1.133,245.52,0,239.957,0 
               c-8.352,0-16.223,2.566-22.682,6.939c-6.467,4.366-11.592,10.539-14.682,17.829c-2.058,4.861-3.19,10.223-3.19,15.793 
               c-0.007,8.344,2.566,16.223,6.932,22.682c0.487,0.717,1.004,1.42,1.542,2.101c-79.76,15.04-140.115,85.037-140.115,169.171v77.245 
               c0,18.374-12.976,73.509-41.332,90.987C-62.877,457.789,90.723,512,239.957,512S542.791,457.789,453.481,402.747z 
               M227.34,32.067c1.649-2.438,3.985-4.38,6.703-5.52c1.813-0.767,3.785-1.197,5.914-1.197c3.19,0.007,6.058,0.954,8.495,2.595 
               c2.438,1.642,4.38,3.986,5.528,6.703c0.76,1.807,1.183,3.778,1.183,5.915c-0.007,3.19-0.946,6.05-2.588,8.487 
               c-1.642,2.438-3.986,4.38-6.696,5.528c-1.814,0.76-3.786,1.19-5.922,1.19c-3.19-0.007-6.05-0.946-8.495-2.588 
               c-2.43-1.649-4.373-3.993-5.52-6.71c-0.76-1.807-1.19-3.771-1.19-5.907C224.759,37.364,225.698,34.504,227.34,32.067z"
        ></path>
        <path
          style={{ fill: "#EBB75A" }}
          d="M476.393,444.247c0,37.414-106.55,67.753-237.999,67.753c-131.44,0-237.988-30.339-237.988-67.753 
               c0-37.414,106.548-67.753,237.988-67.753C369.843,376.494,476.393,406.833,476.393,444.247z"
        ></path>
        <path
          style={{ fill: "#F7BB62" }}
          d="M254.166,35.084c4.373,11.19-4.854,19.858-14.209,20.367V512c24.016,0,48.046-1.362,71.904-4.043 
               c26.159-2.939,52.211-7.406,77.696-14.073c20.267-5.327,40.59-11.914,59.043-21.972c11.47-6.237,24.754-14.782,29.708-27.543 
               c4.559-11.75-1.771-22.832-10.309-30.812c-6.933-6.481-15.65-10.523-22.475-17.047c-8.129-7.778-14.043-17.693-18.718-27.829 
               c-8.115-17.542-14.66-38.168-14.66-57.645v-72.95c0-38.26-10.882-75.194-33.83-106.092 
               c-25.629-34.532-63.975-58.713-106.264-66.671C292.24,39.156,272.977-0.014,239.957,0v25.665 
               c5.456-0.294,10.969,2.193,13.836,8.559l0.086,0.201c0.036,0.071,0.072,0.143,0.101,0.229c0.036,0.101,0.093,0.186,0.122,0.287 
               C254.144,35.035,254.166,35.084,254.166,35.084z"
        ></path>
        <g>
          <path
            style={{ fill: "#AD7E42" }}
            d="M195.396,397.599c-99.816,4.667-174.91,24.905-174.91,49.193 
                 c0,27.658,97.472,50.082,217.908,50.204V396.588C223.684,396.603,209.296,396.94,195.396,397.599z"
          ></path>
          <path
            style={{ fill: "#9E703B" }}
            d="M288.031,397.829c-15.657-0.824-31.915-1.248-48.633-1.248c-0.33,0-0.667,0.007-1.004,0.007 
                 v100.408c0.337,0,0.674,0.007,1.004,0.007c120.91,0,218.923-22.474,218.923-50.21C458.321,422.891,385.535,402.89,288.031,397.829 
                 z"
          ></path>
        </g>
        <path
          style={{ fill: "#ECC052" }}
          d="M295.337,424.841c0,29.657-24.044,53.702-53.688,53.702c-29.643,0-53.68-24.044-53.68-53.702 
               c0-9.943,2.71-19.263,7.427-27.242c14.223-0.674,28.941-1.018,44.002-1.018c16.718,0,32.977,0.424,48.633,1.248 
               C292.684,405.757,295.337,414.998,295.337,424.841z"
        ></path>
        <circle
          style={{ fill: "#FFFFFF" }}
          cx="222.329"
          cy="448.799"
          r="11.047"
        ></circle>
        <g>
          <path
            style={{ fill: "#FFFFFF" }}
            d="M114.499,218.615c0.007-25.005,7.947-48.11,21.474-67.058 
                 c13.52-18.933,32.625-33.657,54.834-41.715c5.262-1.914,7.979-7.721,6.072-12.99c-1.915-5.262-7.729-7.972-12.99-6.058 
                 c-26.145,9.484-48.54,26.747-64.423,48.984c-15.882,22.224-25.256,49.494-25.248,78.836c0,5.592,4.541,10.13,10.136,10.13 
                 C109.957,228.744,114.499,224.206,114.499,218.615L114.499,218.615z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

const POIsSvg = () => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
    role="img"
    className="iconify iconify--gis"
    preserveAspectRatio="xMidYMid meet"
    fill="#e41111"
    stroke="#e41111"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M50.001 0C33.65 0 20.25 13.36 20.25 29.666c0 6.318 2.018 12.19 5.433 17.016L46.37 82.445c2.897 3.785 4.823 3.066 7.232-.2l22.818-38.83c.46-.834.822-1.722 1.137-2.629a29.28 29.28 0 0 0 2.192-11.12C79.75 13.36 66.354 0 50.001 0zm0 13.9c8.806 0 15.808 6.986 15.808 15.766c0 8.78-7.002 15.763-15.808 15.763c-8.805 0-15.81-6.982-15.81-15.763c0-8.78 7.005-15.765 15.81-15.765z"
        fill="#e41111"
      ></path>
      <path
        d="M68.913 48.908l-.048.126c.015-.038.027-.077.042-.115l.006-.011z"
        fill="#e41111"
      ></path>
      <path
        d="M34.006 69.057C19.88 71.053 10 75.828 10 82.857C10 92.325 26.508 100 50 100s40-7.675 40-17.143c0-7.029-9.879-11.804-24.004-13.8l-1.957 3.332C74.685 73.866 82 76.97 82 80.572c0 5.05-14.327 9.143-32 9.143c-17.673 0-32-4.093-32-9.143c-.001-3.59 7.266-6.691 17.945-8.174c-.645-1.114-1.294-2.226-1.94-3.341z"
        fill="#e41111"
      ></path>
    </g>
  </svg>
);

const getIsNeutralSvg = (isNeutral) => {
  if (!isNeutral) {
    return (
      <svg
        fill="#000000"
        width="25px"
        height="25px"
        viewBox="0 0 56 56"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M 9.1211 36.2500 C 9.1211 47.8047 15.5195 52.9844 24.4492 52.9844 C 30.1211 52.9844 34.3398 51.1094 37.7148 47.5703 C 42.4023 42.6016 43.9492 35.0782 44.8398 32.125 C 45.5430 29.8047 46.8789 26.8282 46.8789 25.2578 C 46.8789 24.2500 45.5430 23.3594 44.6523 23.3594 C 42.6367 23.3594 41.8867 24.2734 40.6914 26.8047 C 39.3789 29.5938 37.7852 34.7969 36.5195 34.7969 C 35.7930 34.7969 35.5352 33.5078 35.5352 31.0469 L 35.5352 8.4297 C 35.5352 7.1875 34.7852 6.0625 33.1914 6.0625 C 31.6211 6.0625 30.8476 7.1875 30.8476 8.4297 L 30.8476 26.9453 C 30.0976 26.7344 29.2305 26.5703 28.2930 26.4297 L 28.2930 5.3594 C 28.2930 4.1172 27.5195 3.0156 25.9492 3.0156 C 24.3789 3.0156 23.6055 4.1172 23.6055 5.3594 L 23.6055 26.2656 C 22.7383 26.3125 21.8945 26.4063 21.0508 26.5469 L 21.0508 7.1641 C 21.0508 5.9219 20.2539 4.7969 18.7070 4.7969 C 17.1601 4.7969 16.3633 5.9219 16.3633 7.1641 L 16.3633 27.8594 C 15.4492 28.2344 14.5820 28.6797 13.8086 29.1719 L 13.8086 14.4531 C 13.8086 13.2109 13.0820 12.0860 11.5117 12.0860 C 9.8945 12.0860 9.1211 13.2109 9.1211 14.4531 Z"></path>
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        fill="#000000"
        width="25px"
        height="25px"
        viewBox="0 0 56 56"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M 45.1094 42.5782 C 47.2656 38.5000 48.2031 34.2109 48.8125 32.125 C 49.5157 29.8047 50.8516 26.8282 50.8516 25.2578 C 50.8516 24.2500 49.5157 23.3594 48.6484 23.3594 C 46.6094 23.3594 45.8594 24.2734 44.6641 26.8047 C 43.3516 29.5938 41.7578 34.7969 40.5156 34.7969 C 39.7656 34.7969 39.5078 33.5078 39.5078 31.0469 L 39.5078 8.4297 C 39.5078 7.1875 38.7578 6.0625 37.1641 6.0625 C 35.5938 6.0625 34.8203 7.1875 34.8203 8.4297 L 34.8203 26.9453 C 34.0703 26.7344 33.2265 26.5703 32.2656 26.4531 L 32.2656 5.3594 C 32.2656 4.1172 31.4922 3.0156 29.9219 3.0156 C 28.3516 3.0156 27.5781 4.1172 27.5781 5.3594 L 27.5781 25.0938 Z M 25.0234 22.5391 L 25.0234 7.1641 C 25.0234 5.9219 24.2265 4.7969 22.6797 4.7969 C 21.1328 4.7969 20.3360 5.9219 20.3360 7.1641 L 20.3360 17.8516 Z M 45.1328 51.7422 C 45.8594 52.4922 47.0312 52.4219 47.6875 51.7422 C 48.3906 51.0156 48.3672 49.8906 47.6875 49.1875 L 8.4062 9.9297 C 7.6797 9.2031 6.5312 9.2500 5.8281 9.9297 C 5.1484 10.6094 5.1719 11.8047 5.8281 12.4844 Z M 17.7812 15.3438 L 17.7812 13.5156 C 17.7812 12.2734 17.0547 11.1484 15.4844 11.1484 C 14.9453 11.1484 14.3828 11.3828 14.1719 11.6641 Z M 13.0938 36.2500 C 13.0938 47.8047 19.5156 52.9844 28.4219 52.9844 C 32.8281 52.9844 36.2969 51.8594 39.2500 49.7266 L 13.0938 23.5938 Z"></path>
        </g>
      </svg>
    );
  }
};

const DirectionalCarSVG = (direction) => {
  const directions = {
    N: 0,
    NE: 45,
    E: 90,
    SE: 135,
    S: 180,
    SW: 225,
    W: 270,
    NW: 315,
  };

  const rotationAngle = directions[direction] || 0; // Fallback to 0 if direction is invalid
  //console.log("rotationAngle", rotationAngle);

  return (
    <svg
      fill="#3366ff"
      height="65px"
      width="65px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 47.032 47.032"
      xmlSpace="preserve"
      style={{
        transform: `rotate(${rotationAngle}deg)`,
        animation: "rotate-swing 5s infinite",
      }} // Apply rotation and animation
    >
      <style>
        {`
            @keyframes rotate-swing {
              0% { transform: rotate(${rotationAngle - 45}deg); }
              50% { transform: rotate(${rotationAngle + 45}deg); }
              100% { transform: rotate(${rotationAngle - 45}deg); }
            }
          `}
      </style>
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path
            d="M29.395,0H17.636c-3.117,0-5.643,3.467-5.643,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644V6.584C35.037,3.467,32.511,0,29.395,0z"
            fill="#3366ff"
          ></path>
          <path
            d="M34.05,14.188v11.665l-2.729,0.351v-4.806L34.05,14.188z M32.618,10.773c-1.016,3.9-2.219,8.51-2.219,8.51H16.631l-2.222-8.51C14.41,10.773,23.293,7.755,32.618,10.773z M15.741,21.713v4.492l-2.73-0.349V14.502L15.741,21.713z M13.011,37.938V27.579l2.73,0.343v8.196L13.011,37.938z M14.568,40.882l2.218-3.336h13.771l2.219,3.336H14.568z M31.321,35.805v-7.872l2.729-0.355v10.048L31.321,35.805z"
            fill="#99b3ff"
          ></path>
          <text
            x="23.516"
            y="29"
            textAnchor="middle"
            fontSize="12"
            fill="#FFFFFF"
            fontFamily="Arial"
            dy=".3em"
          >
            34
          </text>
        </g>
      </g>
    </svg>
  );
};

const CarMarker = (rotationAngle, label, hsl1, hsl2) => {
  const svg = `
    <svg
      fill="#3366ff"
      height="50px"
      width="50px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 47.032 47.032"
      xml:space="preserve"
      style="transform: rotate(${rotationAngle}deg); animation: rotate-swing 5s infinite;"
    >
      <style>
        @keyframes rotate-swing {
          0% { transform: rotate(${rotationAngle - 5}deg); }
          50% { transform: rotate(${rotationAngle + 5}deg); }
          100% { transform: rotate(${rotationAngle - 5}deg); }
        }
      </style>
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path
            d="M29.395,0H17.636c-3.117,0-5.643,3.467-5.643,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644V6.584C35.037,3.467,32.511,0,29.395,0z"
            fill="${hsl1}"
            stroke="black"
            stroke-width="0.5"
          ></path>
          <path
            d="M34.05,14.188v11.665l-2.729,0.351v-4.806L34.05,14.188z M32.618,10.773c-1.016,3.9-2.219,8.51-2.219,8.51H16.631l-2.222-8.51C14.41,10.773,23.293,7.755,32.618,10.773z M15.741,21.713v4.492l-2.73-0.349V14.502L15.741,21.713z M13.011,37.938V27.579l2.73,0.343v8.196L13.011,37.938z M14.568,40.882l2.218-3.336h13.771l2.219,3.336H14.568z M31.321,35.805v-7.872l2.729-0.355v10.048L31.321,35.805z"
            fill="${hsl2}"
            stroke="black"
            stroke-width="0.5"
          ></path>
          <text
            x="23.516"
            y="29"
            text-anchor="middle"
            font-size="12"
            fill="#FFFFFF"
            font-family="Arial"
            dy=".3em"
          >
            ${label}
          </text>
        </g>
      </g>
    </svg>

  `;

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new window.google.maps.Size(50, 50), // Marker size
    anchor: new window.google.maps.Point(32.5, 32.5), // Center the anchor (half of width and height)
  };
};

const OnTrailPowerOnOff = (eventColor, hsl1, hsl2) => {
  const svg = `
    <svg width="20px" height="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000">
      <g id="SVGRepo_bgCarrier" stroke-width="0"/>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
      <g id="SVGRepo_iconCarrier">
        <circle style="fill:${hsl1};" cx="256" cy="256" r="256"/>
        <path style="fill:${hsl1};" d="M437.019,437.019c37.211-37.21,60.561-83.03,70.072-131.046l-151.15-151.15L237.611,270.641 l-78.624,89.345l147.085,147.085C354.052,497.548,399.834,474.205,437.019,437.019z"/>
        <circle style="fill:#ffffff;" cx="256" cy="256" r="142.222"/>
        <path style="fill:#ffffff;" d="M256,113.778c-0.193,0-0.381,0.014-0.574,0.014v284.415c0.193,0,0.381,0.014,0.574,0.014 c78.546,0,142.222-63.676,142.222-142.222S334.546,113.778,256,113.778z"/>
        <g>
          <rect x="241.347" y="170.667" style="fill:${eventColor};" width="29.306" height="85.333"/>
          <path style="fill:${eventColor};" d="M256,355.987c-26.707,0-51.817-10.4-70.703-29.284c-38.984-38.984-38.984-102.419,0-141.403 l20.723,20.723c-13.35,13.348-20.702,31.099-20.702,49.978s7.352,36.63,20.702,49.978c13.348,13.35,31.099,20.702,49.978,20.702 s36.63-7.352,49.978-20.702c13.35-13.348,20.702-31.099,20.702-49.978s-7.352-36.63-20.702-49.978l20.723-20.723 c38.984,38.984,38.984,102.419,0,141.403C307.817,345.586,282.707,355.987,256,355.987z"/>
        </g>
        <g>
          <rect x="255.431" y="170.667" style="fill:${eventColor};" width="15.227" height="85.333"/>
          <path style="fill:${eventColor};" d="M326.703,185.297l-20.723,20.723c13.35,13.348,20.702,31.099,20.702,49.978 s-7.352,36.63-20.702,49.978c-13.348,13.35-31.099,20.702-49.978,20.702c-0.191,0-0.383-0.012-0.574-0.014v29.306 c0.191,0.002,0.383,0.014,0.574,0.014c26.707,0,51.817-10.4,70.703-29.284C365.687,287.716,365.687,224.284,326.703,185.297z"/>
        </g>
      </g>
    </svg>

  `;

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new window.google.maps.Size(20, 20), // Marker size
  };
};

const ResultIconWithRank = (rank, size = "25px") => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    className="iconify iconify--emojione"
    preserveAspectRatio="xMidYMid meet"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g fill="#f2b200">
        <path d="M12.7 31.7c-.5 0-1.1-.1-1.5-.4c-1.3-.7-2.9-2.5-2.9-7.3c0-10-5.4-15.8-5.4-15.8l-.9-1L6.7 2l.8 1.2c.1.1 2.6 3.7 6.5 2.7l.5 2.6c-3.9 1-6.7-1.1-8.1-2.6l-1 1.3c1.7 2.2 5.3 8 5.3 16.8c0 2.6.5 4.4 1.5 4.9c.7.4 1.8 0 2.8-1c2.6-2.6 4.5-9 4.5-9l2.2.8c-.1.3-2.1 7.2-5.2 10.2c-1.3 1.2-2.6 1.8-3.8 1.8"></path>
        <path d="M51.3 31.7c.5 0 1.1-.1 1.5-.4c1.3-.7 2.9-2.5 2.9-7.3c0-10.1 5.3-15.8 5.4-15.9l.9-.9L57.3 2l-.8 1.2c-.1.1-2.6 3.7-6.5 2.7l-.5 2.6c3.9 1 6.7-1.1 8.1-2.6l1.2 1.3c-1.7 2.2-5.3 8-5.3 16.8c0 2.6-.5 4.4-1.5 4.9c-.7.4-1.8 0-2.8-1c-2.6-2.6-4.5-9-4.5-9l-2.2.8c.1.3 2.1 7.2 5.2 10.2c1.1 1.2 2.4 1.8 3.6 1.8"></path>
        <path d="M29 24.9h6.1v24.5H29z"></path>
      </g>
      <path fill="#ffce31" d="M30.2 24.9h3.6v24.5h-3.6z"></path>
      <path
        d="M11.8 2C13.5 17.4 21.9 29.7 32 29.7S50.5 17.4 52.2 2H11.8z"
        fill="#f2b200"
      ></path>
      <path
        d="M15.7 2c1.4 15.6 8.2 28 16.3 28S46.9 17.6 48.3 2H15.7z"
        fill="#ffce31"
      ></path>
      <path d="M47.6 54H16.4s7-9 15.6-9s15.6 9 15.6 9" fill="#f2b200"></path>
      <path
        d="M43.9 54H20.1s5.3-9.2 11.9-9.2S43.9 54 43.9 54z"
        fill="#ffce31"
      ></path>
      <path fill="#bc845e" d="M11.8 56h40.4v6H11.8z"></path>
      <path fill="#916140" d="M16.4 54h31.3v2H16.4z"></path>
      <path fill="#f2b200" d="M22 57.5h20v3H22z"></path>
      <path fill="#ce9c7a" d="M11.8 56h2v6h-2z"></path>
      <path fill="#916140" d="M50.2 56h2v6h-2z"></path>
      <path fill="#ffce31" d="M23 57.5h18v3H23z"></path>
      <text
        x="2rem"
        y="15"
        textAnchor="middle"
        fill="#916140"
        fontWeight="700"
        fontSize="20"
        fontFamily="Arial"
        dy=".3em"
      >
        {rank}
      </text>
    </g>
  </svg>
);

const Circle = (fill, size = "20px") => {
  //console.log("passed color", fill);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill={fill} />
    </svg>
  );
};

const MarkerCircle = (fill, size = "20px") => {
  const svg = `
    <svg width="${size}" height="${size}" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="${fill}" />
    </svg>
  `;

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
  };
};

const RotatingOffRadar = () => {
  const svgStyle = {
    animation: "rotation 2s infinite linear",
  };

  return (
    <svg
      fill="#000000"
      height="20px"
      width="20px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 57.997 57.997"
      xmlSpace="preserve"
      style={svgStyle}
    >
      <style>
        {`
            @keyframes rotation {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          `}
      </style>
      <g>
        <path d="M50.184,9.217l2.51-2.51c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0l-2.51,2.509 C43.386,2.767,36.405,0,28.997,0C22.953,0,17.214,1.84,12.32,5.294c-0.919-0.829-2.085-1.297-3.333-1.297 c-1.336,0-2.591,0.52-3.535,1.464c-1.882,1.882-1.929,4.895-0.176,6.855C-2.769,23.73-1.462,39.559,8.482,49.503 c5.478,5.478,12.76,8.494,20.506,8.494s15.028-3.017,20.506-8.494C60.563,38.434,60.788,20.573,50.184,9.217z M48.08,48.089 c-5.1,5.1-11.88,7.908-19.092,7.908s-13.992-2.809-19.092-7.908C0.652,38.844-0.58,24.133,6.872,13.511 c0.157,0.074,0.318,0.136,0.482,0.193c0.058,0.02,0.118,0.035,0.176,0.053c0.247,0.075,0.497,0.135,0.755,0.171 c0.153,0.023,0.307,0.037,0.463,0.045c0.081,0.004,0.158,0.023,0.239,0.023c1.336,0,2.592-0.521,3.535-1.465 c0.217-0.217,0.403-0.454,0.571-0.7c0.065-0.094,0.118-0.192,0.176-0.289c0.089-0.151,0.171-0.304,0.243-0.462 c0.059-0.13,0.115-0.259,0.162-0.392c0.043-0.122,0.076-0.246,0.11-0.371c0.166-0.606,0.215-1.23,0.149-1.851 c-0.006-0.055-0.008-0.11-0.016-0.165C13.89,8.095,13.844,7.893,13.79,7.69c-0.017-0.062-0.035-0.122-0.054-0.184 C13.671,7.3,13.599,7.098,13.507,6.9c-0.003-0.006-0.004-0.012-0.007-0.017C18.047,3.686,23.385,2,28.997,2 c6.874,0,13.353,2.559,18.36,7.216l-3.553,3.553c-4.057-3.709-9.27-5.762-14.816-5.762c-5.883,0-11.407,2.285-15.557,6.434 c-8.578,8.578-8.578,22.534,0,31.112c4.149,4.149,9.674,6.435,15.557,6.435s11.407-2.285,15.557-6.435 c3.46-3.46,5.646-8.007,6.242-12.867c0.838-0.224,1.614-0.645,2.244-1.274c1.948-1.949,1.948-5.122,0-7.071 c-0.872-0.872-2.014-1.361-3.234-1.435c-0.971-2.859-2.53-5.503-4.565-7.735l3.54-3.539C58.595,21.207,58.369,37.799,48.08,48.089z M47.758,22.2c-0.286,0.106-0.558,0.24-0.82,0.397c-0.05,0.03-0.105,0.051-0.154,0.082c-0.294,0.19-0.573,0.407-0.826,0.661 c-0.24,0.24-0.452,0.502-0.636,0.779c-0.031,0.047-0.049,0.098-0.078,0.146c-0.145,0.234-0.279,0.474-0.382,0.728 c-0.004,0.011-0.006,0.022-0.01,0.033c-0.232,0.582-0.359,1.206-0.359,1.851c0,0.647,0.127,1.274,0.361,1.858 c0.003,0.008,0.004,0.017,0.008,0.025c0.103,0.254,0.238,0.495,0.383,0.73c0.029,0.047,0.047,0.098,0.077,0.144 c0.184,0.277,0.395,0.538,0.636,0.779c0.214,0.214,0.447,0.399,0.691,0.568c0.099,0.069,0.205,0.125,0.309,0.186 c0.144,0.084,0.288,0.166,0.44,0.235c0.144,0.067,0.29,0.123,0.44,0.175c0.11,0.038,0.221,0.071,0.334,0.101 c0.185,0.051,0.37,0.095,0.561,0.125c0.014,0.002,0.026,0.007,0.04,0.009c-0.604,4.281-2.585,8.271-5.643,11.329 c-3.771,3.771-8.794,5.849-14.143,5.849s-10.371-2.077-14.143-5.849c-7.798-7.798-7.798-20.486,0-28.284 c3.771-3.771,8.794-5.848,14.143-5.848c5.012,0,9.724,1.844,13.402,5.176L28.281,28.29c-0.391,0.391-0.391,1.023,0,1.414 c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l14.104-14.103c1.734,1.92,3.109,4.153,3.987,6.585 C47.776,22.19,47.768,22.196,47.758,22.2z"></path>
        <path d="M31.109,31.118c-0.586,0.586-1.354,0.879-2.121,0.879s-1.535-0.293-2.121-0.879c-1.172-1.172-1.172-3.071,0-4.242 l9.665-9.664c-2.23-1.432-4.825-2.208-7.544-2.208c-3.744,0-7.26,1.454-9.899,4.094s-4.094,6.155-4.094,9.899 s1.454,7.26,4.094,9.899s6.155,4.094,9.899,4.094s7.26-1.454,9.899-4.094s4.094-6.155,4.094-9.899c0-2.719-0.776-5.313-2.207-7.543 L31.109,31.118z"></path>
      </g>
    </svg>
  );
};

const RefreshIcon = () => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <title>refresh</title>
      <desc>Created with Sketch Beta.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Icon-Set-Filled"
          transform="translate(-154.000000, -1141.000000)"
          fill="#000000"
        >
          <path
            d="M184.858,1143.56 C185.397,1143.02 186.009,1142.55 186.009,1142 C186.009,1141.45 185.562,1141 185.009,1141 L175.009,1141 C174.888,1141 174.009,1141 174.009,1142 L174.009,1152 C174.009,1152.55 174.457,1153 175.009,1153 C175.562,1153 175.947,1152.47 176.373,1152.05 L179.152,1149.27 C180.922,1151.36 182,1154.05 182,1157 C182,1163.63 176.627,1169 170,1169 C163.373,1169 158,1163.63 158,1157 C158,1151.06 162.327,1146.13 168,1145.18 L168,1141.14 C160.109,1142.12 154,1148.84 154,1157 C154,1165.84 161.164,1173 170,1173 C178.836,1173 186,1165.84 186,1157 C186,1152.94 184.484,1149.25 181.993,1146.43 L184.858,1143.56"
            id="refresh"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

const CrossIcon = (size = "25px", color = "#747272") => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 490 490"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill={color}
    stroke={color}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 489.292,457.678 277.331,245.004 489.292,32.337"></polygon>
    </g>
  </svg>
);

const NewCar = (rotationAngle, label, hsl1, hsl2) => {
  const svg = `
    <svg width="150px" height="150px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 508.57 1024">
  <defs>
    <style>
      .cls-1 {
        fill: url(#linear-gradient-2);
      }

      .cls-2 {
        fill: ${hsl2};
      }

      .cls-3 {
        fill: ${hsl1};
      }

      .cls-4 {
        clip-path: url(#clippath-2);
      }

      .cls-5 {
        fill: #929391;
      }

      .cls-6 {
        fill: ${hsl1};
      }

      .cls-7 {
        clip-path: url(#clippath-1);
      }

      .cls-8 {
        clip-path: url(#clippath-4);
      }

      .cls-9 {
        fill: #aee3d8;
      }

      .cls-10 {
        fill: #fffffe;
      }

      .cls-11 {
        fill: #5a6c63;
      }

      .cls-12 {
        fill: #7dc3b2;
      }

      .cls-13 {
        fill: url(#linear-gradient-5);
      }

      .cls-14 {
        fill: #050607;
      }

      .cls-15 {
        clip-path: url(#clippath);
      }

      .cls-16 {
        fill: none;
      }

      .cls-17 {
        clip-path: url(#clippath-3);
      }

      .cls-18 {
        fill: #282526;
      }

      .cls-19 {
        fill: url(#linear-gradient-3);
      }

      .cls-20 {
        fill: url(#linear-gradient);
      }

      .cls-21 {
        fill: url(#linear-gradient-4);
      }

      .cls-22 {
        fill: #2c2f2d;
      }
    </style>
    <clipPath id="clippath">
      <path class="cls-16" d="M68.29,152.83l.38,3.79c.29-3.2,.04-8.89,2.52-11.21,1.66,.17,2.41,1.17,3.45,2.42,1.03,1.23,1.86,2.27,2.32,3.83-.52,.77-.89,1.06-1.64,1.64-.93,.72-1.64,1.53-1.94,2.72-.35,1.39,.12,3.14,.4,4.51l.47-.1,.18-.6c2.02,3.02,6.67,58.05,7.32,65.2,4.46,49.27,6.39,98.81,8.71,148.22,1.77,37.58,4.89,75.92,2.6,113.51-3.6,51.37-9.25,102.51-16.97,153.42-2.71,18.78-6.97,37.78-9.11,56.5-3.93-5.35-7.42-10.57-10.34-16.55,6.63-36.3,11.31-73.19,15.15-109.9,3.39-32.4,6.24-64.67,7.17-97.25,.45-15.79,0-31.67-.21-47.47-.28-21.05-.5-42.15-1.27-63.18-1.7-42.55-3.69-85.09-5.96-127.61l-2.59-47.47c-.58-10.7-2.8-23.98-.62-34.43h0Z"/>
    </clipPath>
    <linearGradient id="linear-gradient" x1="-4276.7" y1="1793.3" x2="-4276.42" y2="1793.3" gradientTransform="translate(-690169.25 240164.31) rotate(-176.4) scale(157.57)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#78ada7"/>
      <stop offset="1" stop-color="#a2bebd"/>
    </linearGradient>
    <clipPath id="clippath-1">
      <path class="cls-16" d="M96.96,453.2c8.55-1.48,17-2.75,25.64-3.49-1.57,9.25-2.06,18.87-2.92,28.21-1.82,19.62-3.4,39.26-4.74,58.92-3.45,48-16.44,112.62,13.53,154.59,20.17,28.25,58.85,39.51,91.67,44.81,46.86,7.57,94.47,3.67,140.23-8.41,7.01-1.85,14.63-3.41,21.42-5.89,2.04,1.76,4,3.78,6.23,5.27-5.98,4.13-14.28,6.66-21.1,9.19-38.26,14.17-77.73,20.59-118.5,20.81-2.99,0-5.98-.04-8.97-.13-2.99-.08-5.98-.21-8.96-.37-2.99-.16-5.97-.37-8.95-.62-2.98-.25-5.96-.53-8.93-.86s-5.94-.69-8.9-1.11c-2.97-.41-5.92-.86-8.87-1.35-2.95-.49-5.89-1.02-8.83-1.59-2.94-.57-5.86-1.18-8.78-1.83-2.92-.65-5.83-1.34-8.73-2.07-2.9-.73-5.79-1.5-8.67-2.31-2.88-.81-5.75-1.66-8.6-2.55-2.85-.89-5.7-1.82-8.53-2.78-2.83-.97-5.65-1.97-8.45-3.01-2.8-1.05-5.59-2.13-8.37-3.25-2.77-1.12-5.53-2.28-8.27-3.47s-5.47-2.43-8.18-3.7c-11.63-5.38-24.57-11.31-33.7-20.52-2.84-2.87-5.12-5.97-4.99-10.15,.28-8.68,3.01-17.71,4.54-26.29,2.33-13.03,4.09-26.19,5.9-39.3,5.01-34.56,8.94-69.25,11.77-104.05,1.35-14.94,3.16-29.94,3.79-44.93,.39-9.24,.16-18.51,.22-27.76h0Z"/>
    </clipPath>
    <linearGradient id="linear-gradient-2" x1="-4259.91" y1="1777.93" x2="-4259.63" y2="1777.93" gradientTransform="translate(3344834.26 4503438.06) rotate(76.05) scale(1215.17)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#161c18"/>
      <stop offset="1" stop-color="#1c1716"/>
    </linearGradient>
    <clipPath id="clippath-2">
      <path class="cls-16" d="M47.63,338.09l.19-116.19c.09-21.05-2.11-46.92,2.39-67.33,6.92-31.41,25.22-58.08,43.68-83.77,6.54-9.1,13.03-18.61,20.97-26.55,23.96-23.95,57.28-27.84,89.06-32.49,.22,8.94,1.01,16.79,3.73,25.32-36.52,1.51-74.7,3.79-101.19,32.42-17.93,19.38-38.15,55.01-41.53,81.21-1.81,14.02-.4,29.23,.19,43.37,.8,19.06,2.28,38.09,3.2,57.15,2.37,46.39,4.13,92.81,5.3,139.24,.74,25.91,1.86,51.95,1.34,77.87-.24,12.15-1.23,24.39-1.95,36.52-1.87,33.94-4.99,67.77-9.36,101.49-1.76,14.55-3.79,29.08-6.1,43.55-.73,4.77-1.03,11.14-2.59,15.66-1.62-.66-3.91-.07-5.68,.13-1.11-2.51-2.17-4.63-2.27-7.41-1.09-29.77,.16-59.88,.28-89.69l.1-177.77c3.81,1.49,9.58,3.61,13.54,1.79,1.95-.9,2.97-2.67,3.46-4.68,1.48-5.99-1.75-11.97-3.01-17.72-1.91-8.66-2.06-17.78-7.08-25.45-1.86-2.83-3.99-4.66-6.66-6.68h0Z"/>
    </clipPath>
    <linearGradient id="linear-gradient-3" x1="-4253.52" y1="1777.55" x2="-4253.24" y2="1777.55" gradientTransform="translate(2377058.93 -974195.14) rotate(.39) scale(557.27)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#c0282d"/>
      <stop offset="1" stop-color="#e93133"/>
    </linearGradient>
    <clipPath id="clippath-3">
      <path class="cls-16" d="M54.27,683.1c2,3,4.1,5.84,5.15,9.32,.09,.3,.2,.6,.29,.9,2.67,8.86,3.89,24.26,5.74,34.12l18.8,103.09c2.36,12.77,4.19,30.1,9.62,41.65,2.99,6.35,8.39,11.23,14.46,14.57,11.85,6.51,26.04,9.65,39.18,12.52,56.94,12.4,117.05,12.96,174.82,6.94,19.17-1.99,39.07-4.55,57.59-10.03,12.94-3.83,26.76-9.94,33.76-22.2,4.26-7.46,4.9-20.71,6.51-29.21,6.13-32.58,11.87-65.24,17.21-97.96l4.75-28.96c1.08-7,1.86-14.2,3.44-21.1,.65-2.86,1.57-5.18,3.26-7.59,1.68,5.2,.79,12.81,1.14,18.34,.79,12.52,1.98,24.99,2.55,37.53,.63,16.87,.91,33.75,.83,50.63,.05,12.01,.68,24.41-.84,36.34-1.37,10.74-5,21.33-9.95,30.94-13.64,26.53-37.43,42.6-65.35,51.45-7.54,2.39-15.17,4.45-22.9,6.17-7.72,1.72-15.51,3.1-23.35,4.13-56.3,7.79-168.48,8.7-218.38-17.29-25.63-13.35-45.89-35.07-54.54-62.84-4.61-14.8-4.65-30.44-5.04-45.8l-1.14-48.54c-.12-6.92,.3-14.06-.15-20.94,.41-14.73-.41-31.8,2.52-46.18Z"/>
    </clipPath>
    <linearGradient id="linear-gradient-4" x1="-4255.34" y1="1782.53" x2="-4255.06" y2="1782.53" gradientTransform="translate(-994139.52 -4427277.85) rotate(-79.93) scale(983.72)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#e4cac8"/>
      <stop offset="1" stop-color="#dee5e0"/>
    </linearGradient>
    <clipPath id="clippath-4">
      <path class="cls-16" d="M406.06,944.72c2-.59,3.86-1.38,5.77-2.22,16-7.06,40.85-24.4,51.37-38.34,2.27-3.01,3.8-6.32,5.17-9.81l.69,.09c-2.52,12.85-4.44,26.69-10.77,38.34-10.36,27-32.87,48.87-59.14,60.49-34.91,15.44-118.66,20.8-158.18,19.72-20.08-.55-39.89-2.86-59.86-4.75-4.69-3.47-12.18-2.94-17.71-4.62-8.89-2.7-17.62-5.96-26.49-8.73-21.42-6.69-40.61-11.71-58.78-25.98-6.89-5.41-12.67-12.04-18.75-18.32-1.09-1.12-1.38-1.19-2.89-1.59-8.53-13.63-17.29-36.35-19.13-52.48l.55-.05,2.41,2.12c13.05,16.82,28.78,30.02,47.96,39.3,4,1.93,8.52,4.24,12.86,5.24,6.69-.02,14.25,3.88,20.93,5.08,16.37,4.71,33.33,6.8,50.2,8.74,12.31,1.43,24.66,2.53,37.03,3.31,12.37,.78,24.76,1.22,37.15,1.34,12.4,.12,24.79-.09,37.17-.63,12.39-.54,24.75-1.4,37.09-2.6,11.04-1.01,23.4-1.54,34.14-4.23,17.32-.66,34.06-8.16,51.23-9.42h0Z"/>
    </clipPath>
    <linearGradient id="linear-gradient-5" x1="-4259.15" y1="1783.35" x2="-4258.87" y2="1783.35" gradientTransform="translate(-6330211.86 -586084.84) rotate(-151.98) scale(1376.91)" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#939595"/>
      <stop offset="1" stop-color="#b9b4ae"/>
    </linearGradient>
  </defs>
  <g id="svg2">
    <g id="g8">
      <g id="g10">
        <path id="path14" class="cls-14" d="M248.7,.14c3.93-.17,7.89-.13,11.82-.13,29.59-.05,78.28,3.19,105.49,14.83,12.47,5.34,24.24,13.83,33.78,23.42,27.01,27.15,61.46,84.48,68.53,122.04,3.5,18.57,1.9,40.06,1.93,59.04l-.32,112.38c8.79-1.73,22.33-6.26,30.99-3.84,2.73,.77,4.82,2.41,6.12,4.94,3.29,6.41,.52,21.64-1.59,28.49-.69,2.23-1.57,4.37-3.14,6.13-6.44,7.19-23.5,13.73-32.42,18.66l-.16,160.58,.1,79.45c.05,13.05-.71,26.39,.04,39.39,.42,7.36,4.05,14.24,5.95,21.34,4.38,16.37,7.86,32.95,8.7,49.91,1.06,21.45,.11,43.39,.13,64.88,.06,59.18,1.88,126.06-40.93,172.61-1.39,1.49-2.82,2.95-4.29,4.36-1.46,1.42-2.97,2.8-4.5,4.15-1.53,1.34-3.1,2.65-4.7,3.91-1.6,1.27-3.23,2.49-4.89,3.68-1.66,1.18-3.35,2.33-5.06,3.43s-3.46,2.16-5.23,3.17-3.57,1.98-5.39,2.91c-1.82,.92-3.66,1.8-5.52,2.63-36.5,15.94-98.27,19.57-138.74,21.45-.83,.02-1.66,.03-2.49,.03-17.66,.1-35.29-.51-52.9-1.82-17.61-1.31-35.14-3.31-52.59-6.01-18.51-2.78-38.33-5.95-55.66-13.21-13.58-5.69-25.36-13.94-35.78-24.29-24.23-24.07-37.18-58.65-41.07-92.17-1.52-13.14-1.41-26.44-1.52-39.64l-.3-46.68c-.07-15.31,0-30.63,.22-45.94,.14-15.11,.22-30.17,1.99-45.21,1.14-9.7,2.92-19.56,5.43-29,2.47-9.28,5.71-12.93,6.02-23.46,.95-32.67,.37-65.53,.39-98.21v-172.83c-9.96-6.1-24.83-10.19-32.37-19.28-4.65-5.6-5.38-21.55-4.36-28.57,.42-2.89,1.48-5.73,3.99-7.42,5.78-3.88,25.99,1.27,32.94,2.66l-.07-108.95c.03-22.89-1.72-52.19,3.29-74.02,1.32-5.53,2.92-10.97,4.83-16.32,1.9-5.35,4.09-10.59,6.56-15.7,6.96-14.43,16.08-27.62,25.01-40.87,8.81-13.06,18.03-27.02,28.88-38.45C139.47,3.19,202.65,1.33,248.7,.14"/>
        <path id="path16" class="cls-6" d="M49.27,665.71c1.77-.2,4.06-.8,5.68-.13l-1.34,9.57c-1.58-3.06-2.91-6.3-4.34-9.44"/>
        <path id="path18" class="cls-6" d="M415.56,231.86c1.11,6.29,2.08,12.53,2.11,18.94-2.38-2.12-4.72-4.29-7.22-6.27,.86-1.92,.35-4.5,.21-6.57l.97,2.18c.96-.52,1.95-6.26,3.94-8.28"/>
        <path id="path20" class="cls-10" d="M257.47,906.29c-1.25-.4-1.35-.48-2.17-1.51-.37-5.76-.07-11.65-.08-17.42l-.17-29.7c-.18-30.15-.62-60.41-.36-90.55,.01-1.32,.01-2.84,.69-4.02,.42-.72,1.42-.72,2.17-.92,.56,26.07-.04,52.22,.08,78.31,.05,10.46,1.52,60.4-.16,65.81"/>
        <path id="path22" class="cls-11" d="M207.92,11.51c12.57-.47,85.14-2.69,92.05,.74,.2,1.82,.16,3.41-.03,5.22-22.67-1.23-45.24-1.95-67.95-2.24-7.62-.1-15.63,1.33-23.13,.6-.83-1.42-.79-2.73-.94-4.33"/>
        <path id="path24" class="cls-10" d="M64.07,697.27c1.64,2.42,3.3,4.83,4.99,7.23l16.34,89.9c1.95,10.46,15.51,75.29,14.49,80.85-2.61-3.06-3.83-6.68-4.86-10.49-3.42-12.65-5.45-25.95-7.82-38.84-3.57-18.42-6.92-36.88-10.06-55.38-4.24-24.41-9.73-48.72-13.08-73.26"/>
        <path id="path26" class="cls-10" d="M439.25,699.52l1.55-1.91c.66,.57,.47,.22,.56,1.25,.4,4.55-6.76,40.86-8.15,48.78l-11.56,67.15c-2.88,16.98-5.51,34.44-9.68,51.16-1.06,4.23-2.33,7.81-5.36,11.1-.86,.93-1.81,1.78-2.75,2.63-.03-5.77,5.93-26.5,7.36-34.05,4.41-23.28,8.29-46.62,13.05-69.84,5.18-25.3,11.34-50.7,14.98-76.26"/>
        <path id="path28" class="cls-18" d="M87.36,254.68c4.9-4.63,10.69-8,16.72-10.92-.56,14.47,2.1,29.56,5.68,43.54-6.5,1.36-12.93,2.97-19.37,4.59-2.31-11.79-2.61-25.18-3.04-37.21"/>
        <path id="path30" class="cls-5" d="M56.48,948.98c1.51,.4,1.8,.47,2.89,1.59,6.07,6.27,11.85,12.9,18.75,18.32,18.17,14.27,37.36,19.29,58.78,25.98,8.87,2.77,17.6,6.03,26.49,8.73,5.53,1.68,13.02,1.15,17.71,4.62-21.68-2.17-44.35-4.7-65.18-11.38-24.37-7.81-47.51-24.74-59.44-47.86"/>
        <path id="path32" class="cls-6" d="M7.05,335.03c8.3-2.57,26.64,1.79,34.28,5.93,6.17,3.35,9.31,8.21,11.18,14.85,1.93,6.85,3.47,15.1,2.96,22.23-5.84-4.24-11.25-9.45-16.7-14.17-10.86-9.42-21.54-18.64-31.72-28.83"/>
        <path id="path34" class="cls-3" d="M500.11,341.69c-.52,6.7-1.42,13.84-3.41,20.27-4.38,4.03-40.7,23.35-46.21,23-.78-.05-1.58-.72-2.04-1.31-2.21-2.88-.97-8.58-.65-11.89,14.72-6.55,40.32-19.76,52.3-30.07"/>
        <path id="path36" class="cls-3" d="M55.47,378.04c.75,1.65,2.06,4.04,1.69,5.93-.29,1.48-.6,1.6-1.78,2.35-1.8-.04-3.36-.63-5.01-1.32-7.36-3.08-40.52-18.61-42.7-24.49-1.63-4.4-2.53-21.29-.62-25.49,10.17,10.2,20.85,19.42,31.72,28.83,5.45,4.72,10.86,9.94,16.7,14.17"/>
        <path id="path38" class="cls-6" d="M447.81,371.76c1.09-7.71,2.12-16.88,6.56-23.5,5.36-7.99,15.55-10.46,24.44-12.19,4.21-.81,16.28-3.86,19.77-.8,1.79,1.58,1.52,4.27,1.53,6.41-11.98,10.32-37.58,23.52-52.3,30.07"/>
        <path id="path40" class="cls-3" d="M240.84,762.27l10.34,.13-.1,96.06c-.01,15.78,.36,31.62,.04,47.39l-14.11-.3c1.34-.1,2.33-.07,3.49-.84,1.79-2.9,.05-128.08,.33-142.43"/>
        <path id="path42" class="cls-2" d="M365.98,52.5c2.95,1.36,5.47,2.77,8.07,4.74,5.48,12.66,8.97,30.13,12.5,43.66,5.67,21.72,11.66,43.68,16.43,65.61,4.73,21.71,8.29,43.58,12.57,65.35-1.99,2.03-2.98,7.76-3.94,8.28l-.97-2.18c-.61-4.52-2.85-9.82-4.07-14.28-2.71-10.26-5.34-20.55-7.89-30.85-8.68-34.6-16.88-69.3-24.61-104.13-2.57-11.16-7.39-25.07-8.1-36.21"/>
        <path id="path44" class="cls-18" d="M210.72,35.9c-2.63-7.39-3.56-16.61-2.8-24.38,.15,1.6,.12,2.91,.94,4.33,7.5,.74,15.51-.69,23.13-.6,22.7,.29,45.28,1,67.95,2.24-.48,6.73-1.15,13.13-2.94,19.66-28.6-2.13-57.6-.83-86.28-1.25"/>
        <path id="path46" class="cls-3" d="M255.16,40.46l10.18-.11c-.31,20.41-1.74,40.86-2.64,61.26-1.17,26.3-1.87,53.52-4.68,79.66-.68,6.38-1.85,12.7-2.75,19.05-.79,5.6-.43,11.46-1.52,16.98l-.62-.18c-.19-6.15-1.54-12.4-2.37-18.51-1.08-8.55-2.02-17.12-2.82-25.71-2.93-29.58-5.4-59.19-7.41-88.84-.98-14.33-2.35-28.75-2.61-43.11-6.05,.13-12.2,.35-18.24-.12,10.3-1.41,21.93-.41,32.37-.39-.97,47.1,.1,94.65,1.45,141.74,2.14-9.34,.86-24.01,1.02-34.16,.55-35.85-.08-71.71,.64-107.56"/>
        <path id="path48" class="cls-3" d="M129.29,56.7c6.58-3.31,13.05-6.28,20.13-8.37-18.08,31.83-26.11,98.93-31.95,136.23-1.89,12.07-3.62,24.07-5.06,36.21-.59,5.02-1.61,10.36-1.39,15.41-8.36,3.34-16.1,7.03-23.83,11.63,2.99-13.4,5.3-26.94,8.02-40.39,2.84-14.01,6.11-27.94,8.98-41.95,7.46-36.38,14.89-73.05,25.1-108.78"/>
        <path id="path50" class="cls-10" d="M378.96,59.67c1.14,.75,2.26,1.51,3.37,2.29,24.93,17.59,50.06,65.55,55.07,95.06-.49,.75-.49,1.25-1.47,1.36-1.62,.18-3.22-.66-4.54-1.51-.28-.39-.66-.99-1.05-1.27-1.08-.78-1.7-.73-2.86-.41-.77,.87-.97,1.55-1.17,2.66-1.43,7.7-1.65,16.04-2.35,23.87-1.59,17.83-2.89,35.74-4.94,53.52-4.42-36.23-12.9-71.93-21.63-107.31-5.66-22.89-10.97-45.87-18.42-68.27"/>
        <path id="path52" class="cls-10" d="M68.29,152.83c1.61-25.79,27.08-69.23,46.53-86.27,3.17-2.8,6.55-5.31,10.15-7.54-6.22,21.29-10.78,43.05-15.63,64.68-8.62,37.22-16.32,74.63-23.12,112.23-.88-10.78-5.71-76.78-9.21-81.86l-.87-.15c-.97,.87-1.71,1.55-1.89,2.91-.12,.92,.08,2.07,.18,2.99l-.18,.6-.47,.1c-.28-1.37-.75-3.13-.4-4.51,.3-1.19,1.01-1.99,1.94-2.72,.75-.58,1.12-.88,1.64-1.64-.46-1.56-1.3-2.6-2.32-3.83-1.05-1.25-1.79-2.25-3.45-2.42-2.48,2.32-2.23,8.01-2.52,11.21l-.38-3.79"/>
        <path id="path54" class="cls-3" d="M44.99,662.89c3.14,6.72,6.23,13.46,9.28,20.21-2.93,14.38-2.11,31.44-2.52,46.18-1.44,3.13-.46,15.69-.87,20.29-1.21,13.56-2.07,27.14-3.31,40.7-1.3,14.17-3.41,28.65-2.62,42.88,.65,11.76,3.49,24.07,7.59,35.11,9.48,25.55,28.14,49.53,49.52,66.15,3.79,2.94,18.32,10.63,19.86,13.56,.04,.08,.09,.16,.13,.24-6.68-1.2-14.24-5.1-20.93-5.08-4.34-1-8.86-3.31-12.86-5.24-19.19-9.29-34.92-22.49-47.96-39.3-.88-4.46-4.33-8.29-5.11-13.17-1.2-7.52-.94-15.79-.99-23.4l-.19-33.81c-.17-23.51-.12-47.01,.15-70.52,.15-16.82-.04-33.72,1.72-50.48,1.61-15.3,5.22-29.49,9.11-44.31"/>
        <path id="path56" class="cls-9" d="M437.4,157.02c.81,8.98-.55,18.79-1.15,27.81l-3.96,55.45c-3.33,51.5-5.83,103.03-7.5,154.6-.62,21.37-1.13,42.88-.4,64.25,.91,26.66,3.45,53.42,6.13,79.95,2.77,27.98,5.97,55.91,9.59,83.78,2.56,19.35,5.94,38.59,8.44,57.95-2.31,5.93-5.57,9.23-10.29,13.33-10.45-60.89-18.46-122.1-24.07-183.63-1.51-18.09-3.54-36.38-4.04-54.54-.68-24.88,.56-50.2,1.55-75.08,1.93-52.78,6-105.4,12.21-157.85,1.23-10.67,2.29-21.35,3.2-32.05,.83-9.63,1.12-25.54,4.27-34.15,1.32,.85,2.91,1.7,4.54,1.51,.98-.11,.98-.61,1.47-1.36"/>
        <g id="g58">
          <g class="cls-15">
            <g id="g60">
              <path id="path72" class="cls-20" d="M68.29,152.83l.38,3.79c.29-3.2,.04-8.89,2.52-11.21,1.66,.17,2.41,1.17,3.45,2.42,1.03,1.23,1.86,2.27,2.32,3.83-.52,.77-.89,1.06-1.64,1.64-.93,.72-1.64,1.53-1.94,2.72-.35,1.39,.12,3.14,.4,4.51l.47-.1,.18-.6c2.02,3.02,6.67,58.05,7.32,65.2,4.46,49.27,6.39,98.81,8.71,148.22,1.77,37.58,4.89,75.92,2.6,113.51-3.6,51.37-9.25,102.51-16.97,153.42-2.71,18.78-6.97,37.78-9.11,56.5-3.93-5.35-7.42-10.57-10.34-16.55,6.63-36.3,11.31-73.19,15.15-109.9,3.39-32.4,6.24-64.67,7.17-97.25,.45-15.79,0-31.67-.21-47.47-.28-21.05-.5-42.15-1.27-63.18-1.7-42.55-3.69-85.09-5.96-127.61l-2.59-47.47c-.58-10.7-2.8-23.98-.62-34.43"/>
            </g>
          </g>
        </g>
        <g id="g74">
          <g class="cls-7">
            <g id="g76">
              <path id="path88" class="cls-1" d="M96.96,453.2c8.55-1.48,17-2.75,25.64-3.49-1.57,9.25-2.06,18.87-2.92,28.21-1.82,19.62-3.4,39.26-4.74,58.92-3.45,48-16.44,112.62,13.53,154.59,20.17,28.25,58.85,39.51,91.67,44.81,46.86,7.57,94.47,3.67,140.23-8.41,7.01-1.85,14.63-3.41,21.42-5.89,2.04,1.76,4,3.78,6.23,5.27-5.98,4.13-14.28,6.66-21.1,9.19-38.26,14.17-77.73,20.59-118.5,20.81-2.99,0-5.98-.04-8.97-.13-2.99-.08-5.98-.21-8.96-.37-2.99-.16-5.97-.37-8.95-.62-2.98-.25-5.96-.53-8.93-.86s-5.94-.69-8.9-1.11c-2.97-.41-5.92-.86-8.87-1.35-2.95-.49-5.89-1.02-8.83-1.59-2.94-.57-5.86-1.18-8.78-1.83-2.92-.65-5.83-1.34-8.73-2.07-2.9-.73-5.79-1.5-8.67-2.31-2.88-.81-5.75-1.66-8.6-2.55-2.85-.89-5.7-1.82-8.53-2.78-2.83-.97-5.65-1.97-8.45-3.01-2.8-1.05-5.59-2.13-8.37-3.25-2.77-1.12-5.53-2.28-8.27-3.47s-5.47-2.43-8.18-3.7c-11.63-5.38-24.57-11.31-33.7-20.52-2.84-2.87-5.12-5.97-4.99-10.15,.28-8.68,3.01-17.71,4.54-26.29,2.33-13.03,4.09-26.19,5.9-39.3,5.01-34.56,8.94-69.25,11.77-104.05,1.35-14.94,3.16-29.94,3.79-44.93,.39-9.24,.16-18.51,.22-27.76"/>
            </g>
          </g>
        </g>
        <g id="g90">
          <g class="cls-4">
            <g id="g92">
              <path id="path104" class="cls-19" d="M47.63,338.09l.19-116.19c.09-21.05-2.11-46.92,2.39-67.33,6.92-31.41,25.22-58.08,43.68-83.77,6.54-9.1,13.03-18.61,20.97-26.55,23.96-23.95,57.28-27.84,89.06-32.49,.22,8.94,1.01,16.79,3.73,25.32-36.52,1.51-74.7,3.79-101.19,32.42-17.93,19.38-38.15,55.01-41.53,81.21-1.81,14.02-.4,29.23,.19,43.37,.8,19.06,2.28,38.09,3.2,57.15,2.37,46.39,4.13,92.81,5.3,139.24,.74,25.91,1.86,51.95,1.34,77.87-.24,12.15-1.23,24.39-1.95,36.52-1.87,33.94-4.99,67.77-9.36,101.49-1.76,14.55-3.79,29.08-6.1,43.55-.73,4.77-1.03,11.14-2.59,15.66-1.62-.66-3.91-.07-5.68,.13-1.11-2.51-2.17-4.63-2.27-7.41-1.09-29.77,.16-59.88,.28-89.69l.1-177.77c3.81,1.49,9.58,3.61,13.54,1.79,1.95-.9,2.97-2.67,3.46-4.68,1.48-5.99-1.75-11.97-3.01-17.72-1.91-8.66-2.06-17.78-7.08-25.45-1.86-2.83-3.99-4.66-6.66-6.68"/>
            </g>
          </g>
        </g>
        <path id="path106" class="cls-22" d="M104.09,243.76c11.05-4,21.88-7.67,33.42-10.04,63.92-13.15,160.9-14.37,224.35-.75,11.31,2.43,22.8,5.17,33.33,10.08,5.4,2.52,11.11,5.63,15.31,9.93,.84,7.54,1.52,15.05,1.42,22.65-.06,4.99-.59,9.98-.62,14.97-79.26-22.73-165.15-25.13-246.6-14.69-13.92,1.78-42.58,6.13-54.92,11.41-3.58-13.98-6.24-29.08-5.68-43.54"/>
        <g id="g108">
          <g class="cls-17">
            <g id="g110">
              <path id="path122" class="cls-21" d="M54.27,683.1c2,3,4.1,5.84,5.15,9.32,.09,.3,.2,.6,.29,.9,2.67,8.86,3.89,24.26,5.74,34.12l18.8,103.09c2.36,12.77,4.19,30.1,9.62,41.65,2.99,6.35,8.39,11.23,14.46,14.57,11.85,6.51,26.04,9.65,39.18,12.52,56.94,12.4,117.05,12.96,174.82,6.94,19.17-1.99,39.07-4.55,57.59-10.03,12.94-3.83,26.76-9.94,33.76-22.2,4.26-7.46,4.9-20.71,6.51-29.21,6.13-32.58,11.87-65.24,17.21-97.96l4.75-28.96c1.08-7,1.86-14.2,3.44-21.1,.65-2.86,1.57-5.18,3.26-7.59,1.68,5.2,.79,12.81,1.14,18.34,.79,12.52,1.98,24.99,2.55,37.53,.63,16.87,.91,33.75,.83,50.63,.05,12.01,.68,24.41-.84,36.34-1.37,10.74-5,21.33-9.95,30.94-13.64,26.53-37.43,42.6-65.35,51.45-7.54,2.39-15.17,4.45-22.9,6.17-7.72,1.72-15.51,3.1-23.35,4.13-56.3,7.79-168.48,8.7-218.38-17.29-25.63-13.35-45.89-35.07-54.54-62.84-4.61-14.8-4.65-30.44-5.04-45.8l-1.14-48.54c-.12-6.92,.3-14.06-.15-20.94,.41-14.73-.41-31.8,2.52-46.18"/>
            </g>
          </g>
        </g>
        <path id="path124" class="cls-6" d="M304.16,12.18c32.06,3.06,64.59,9.68,88.32,33.07,25.31,24.96,57.83,80.36,64.62,115.02,4.33,22.1,2.53,45.98,2.53,68.44l-.12,107.36c-3.63,2.55-8.07,6.24-10.19,10.19-4.41,8.22-9.56,29.99-6.6,38.7,.83,2.43,2.37,4.53,4.71,5.65,4.13,1.99,8,.5,12.03-.84l-.4,191.36c-.1,17.05-.09,34.11,.01,51.16,.03,9.84,.55,20.04-.29,29.84-.22,2.51-1.41,4.55-2.58,6.73-1.45,2.52-3.1,4.92-4.71,7.34-1.76-14.45-4.04-28.84-5.89-43.28-4.32-32.56-8.11-65.19-11.35-97.88-2.67-25.87-5.14-52-5.83-78.01-.96-36.14,.51-72.53,2.14-108.62,1.71-38.74,3.88-77.45,6.53-116.14,1.39-20.83,3.24-41.66,4.23-62.52,.24-5.03,.35-10.12-.41-15.12-4.3-28.1-24.86-63.88-43.89-84.67-24.89-27.19-61.57-31.18-96.39-32.66,2.39-8.13,2.67-16.74,3.52-25.12"/>
        <g id="g126">
          <g class="cls-8">
            <g id="g128">
              <path id="path140" class="cls-13" d="M406.06,944.72c2-.59,3.86-1.38,5.77-2.22,16-7.06,40.85-24.4,51.37-38.34,2.27-3.01,3.8-6.32,5.17-9.81l.69,.09c-2.52,12.85-4.44,26.69-10.77,38.34-10.36,27-32.87,48.87-59.14,60.49-34.91,15.44-118.66,20.8-158.18,19.72-20.08-.55-39.89-2.86-59.86-4.75-4.69-3.47-12.18-2.94-17.71-4.62-8.89-2.7-17.62-5.96-26.49-8.73-21.42-6.69-40.61-11.71-58.78-25.98-6.89-5.41-12.67-12.04-18.75-18.32-1.09-1.12-1.38-1.19-2.89-1.59-8.53-13.63-17.29-36.35-19.13-52.48l.55-.05,2.41,2.12c13.05,16.82,28.78,30.02,47.96,39.3,4,1.93,8.52,4.24,12.86,5.24,6.69-.02,14.25,3.88,20.93,5.08,16.37,4.71,33.33,6.8,50.2,8.74,12.31,1.43,24.66,2.53,37.03,3.31,12.37,.78,24.76,1.22,37.15,1.34,12.4,.12,24.79-.09,37.17-.63,12.39-.54,24.75-1.4,37.09-2.6,11.04-1.01,23.4-1.54,34.14-4.23,17.32-.66,34.06-8.16,51.23-9.42"/>
            </g>
          </g>
        </g>
        <path id="path142" class="cls-10" d="M406.06,944.72c2-.59,3.86-1.38,5.77-2.22,16-7.06,40.85-24.4,51.37-38.34,2.27-3.01,3.8-6.32,5.17-9.81l.69,.09c-2.52,12.85-4.44,26.69-10.77,38.34-.23,.16-.47,.31-.71,.48-2.47,1.8-7.84,9.91-11.03,12.97-17.72,17-36.99,30.47-60.61,37.86-2.55,.8-6.86,2.79-9.46,2.57-.18-.02-.35-.07-.53-.11l-.57-.9,.32-.82c.36-.96,.68-1.91,.99-2.89,14.04-6.76,23.05-23.77,29.38-37.21"/>
        <path id="path144" class="cls-14" d="M101.12,943.12c6.69-.02,14.25,3.88,20.93,5.08,16.37,4.71,33.33,6.8,50.2,8.74,12.31,1.43,24.66,2.53,37.03,3.31,12.37,.78,24.76,1.22,37.15,1.34,12.4,.12,24.79-.09,37.17-.63,12.39-.54,24.75-1.4,37.09-2.6,11.04-1.01,23.4-1.54,34.14-4.23,17.32-.66,34.06-8.16,51.23-9.42-6.33,13.44-15.34,30.45-29.38,37.21-13.96,4.28-29.09,6.04-43.53,7.98-6.8,.96-13.62,1.8-20.46,2.52-6.83,.72-13.68,1.32-20.54,1.79-6.86,.47-13.72,.83-20.59,1.06-6.87,.23-13.74,.33-20.61,.32-6.87-.02-13.74-.16-20.61-.42-6.87-.27-13.73-.65-20.58-1.16-6.85-.51-13.7-1.14-20.53-1.89-6.83-.75-13.65-1.62-20.45-2.62-13.24-1.85-28.5-3.42-40.69-9.13-13.53-6.33-22.14-23.92-26.99-37.26"/>
        <path id="path146" class="cls-18" d="M105.8,947.63c21.96,6.84,44.37,9.77,67.16,12.29,7.61,.88,15.24,1.64,22.88,2.28,7.64,.64,15.29,1.15,22.94,1.55,7.66,.39,15.32,.66,22.98,.81,7.67,.15,15.33,.18,23,.07,7.66-.1,15.33-.32,22.98-.66,7.66-.34,15.31-.81,22.95-1.4,7.64-.59,15.27-1.3,22.89-2.13,7.62-.83,15.22-1.79,22.81-2.87,14.77-1.96,29.06-6.15,43.74-8.38-2.7,6.35-5.98,11.93-10.04,17.51-3.59,4.02-7.76,8.47-12.5,11.14-9.73,5.48-29.52,7.22-40.85,8.62-52.94,6.52-97.46,7.84-150.55,1.99-15.62-1.72-31.93-3.59-47.05-7.97-4.68-1.35-10.41-3.14-14.42-5.95-8.11-5.67-14.2-18.27-18.93-26.9"/>
        <path id="path148" class="cls-14" d="M119.49,958.37c6.83,.69,29.68,5.54,33.62,10.74,.84,1.1,1.13,2.36,.8,3.72-.43,1.79-1.77,2.82-3.14,3.88-.43,.08-.85,.15-1.27,.21-8.71,1.13-23.01-4.04-29.74-9.64-1.72-1.42-2.75-2.71-2.95-4.99,.49-1.79,1.43-2.66,2.69-3.93"/>
        <path id="path150" class="cls-14" d="M378.84,960.23c1.29-.19,3.22,.4,4.28,1.18,.97,.72,1.27,2.02,1.15,3.17-.21,2.04-1.66,3.8-3.11,5.14-6,5.54-19.75,9.03-27.73,8.81-.92-.35-1.87-.7-2.74-1.17-1.76-.94-3.43-2.35-3.82-4.4-.28-1.47,.11-2.53,.95-3.72,3.84-5.5,24.23-8.13,31.03-9.01"/>
        <path id="path152" class="cls-6" d="M459.46,670.27c3.59,7.73,5.87,15.91,7.95,24.15,2.51,9.93,4.72,20.02,5.79,30.22,2.04,19.56,1.01,39.92,1.02,59.57,.01,17.84,.47,35.83-.47,53.66,.13,13.03-.57,44.78-4.7,56.54l-.69-.09c-1.36,3.5-2.9,6.81-5.17,9.81-10.52,13.94-35.37,31.28-51.37,38.34-1.9,.84-3.77,1.63-5.77,2.22-17.17,1.25-33.9,8.75-51.23,9.42-10.74,2.69-23.1,3.22-34.14,4.23-12.34,1.2-24.7,2.06-37.09,2.6-12.38,.54-24.78,.75-37.17,.63-12.4-.12-24.78-.56-37.15-1.34-12.37-.78-24.72-1.88-37.03-3.31-16.88-1.93-33.84-4.02-50.2-8.74-.04-.08-.09-.16-.13-.24-1.55-2.93-16.07-10.62-19.86-13.56-21.38-16.62-40.04-40.6-49.52-66.15-4.1-11.03-6.93-23.34-7.59-35.11-.79-14.23,1.32-28.71,2.62-42.88,1.24-13.56,2.11-27.14,3.31-40.7,.41-4.6-.57-17.16,.87-20.29,.45,6.89,.02,14.02,.15,20.94l1.14,48.54c.39,15.36,.43,30.99,5.04,45.8,8.65,27.76,28.91,49.49,54.54,62.84,49.9,25.99,162.09,25.08,218.38,17.29,7.84-1.03,15.63-2.41,23.35-4.13,7.72-1.72,15.35-3.78,22.9-6.17,27.92-8.85,51.71-24.92,65.35-51.45,4.94-9.61,8.58-20.2,9.95-30.94,1.52-11.93,.89-24.32,.84-36.34,.08-16.88-.2-33.76-.83-50.63-.58-12.54-1.77-25.01-2.55-37.53-.35-5.53,.55-13.14-1.14-18.34,3.59-6.26,7.11-12.56,10.6-18.88"/>
        <path id="path154" class="cls-3" d="M354.84,954.13c4.32-3.78,12.52-6.07,17.73-8.68,5.51-2.76,10.78-6.07,16.06-9.25,30.88-18.59,55.84-42.63,73.49-74.27,4.29-7.68,7.25-15.93,11.38-23.6l.25-.46c.13,13.03-.57,44.78-4.7,56.54l-.69-.09c-1.36,3.5-2.9,6.81-5.17,9.81-10.52,13.94-35.37,31.28-51.37,38.34-1.9,.84-3.77,1.63-5.77,2.22-17.17,1.25-33.9,8.75-51.23,9.42"/>
        <path id="path156" class="cls-11" d="M328.7,445.64c23.56,2.31,47.79,3.74,71.02,8.46,5.72,56.34,12.41,112.55,20.09,168.65,2.37,16.71,4.98,33.37,7.85,50,1.41,8.59,2.38,17.37,4.34,25.86-5.2,4.97-10.22,9.37-16.33,13.23-8.14,6.25-18.18,11.36-27.64,15.36-2.23-1.49-4.2-3.51-6.23-5.27l-.06-.21c-.41-.38-.8-.76-1.19-1.16-9.44-9.76-17.54-22.45-23.13-34.79-21.48-47.45-28.01-127.9-29.13-180.42-.42-19.89,.13-39.83,.42-59.72"/>
        <path id="path158" class="cls-22" d="M381.73,721.72c10.19-1.5,24.88-9.27,33.94-9.88-8.14,6.25-18.18,11.36-27.64,15.36-2.23-1.49-4.2-3.51-6.23-5.27l-.06-.21"/>
        <path id="path160" class="cls-6" d="M149.42,48.33c15.47-5.24,53.58-7.68,70.26-7.5,6.04,.47,12.19,.24,18.24,.12,.26,14.36,1.63,28.78,2.61,43.11,2.01,29.65,4.48,59.27,7.41,88.84,.8,8.59,1.73,17.16,2.82,25.71,.83,6.11,2.18,12.35,2.37,18.51-47.22,.04-97.32,3.19-142.11,19.08-.22-5.06,.8-10.39,1.39-15.41,1.44-12.14,3.17-24.14,5.06-36.21,5.84-37.3,13.87-104.4,31.95-136.23"/>
        <path id="path162" class="cls-6" d="M265.34,40.34c24.11-.07,80.22,1.37,100.64,12.15,.71,11.14,5.53,25.05,8.1,36.21,7.73,34.82,15.93,69.53,24.61,104.13,2.55,10.3,5.18,20.59,7.89,30.85,1.22,4.46,3.47,9.76,4.07,14.28,.14,2.07,.65,4.65-.21,6.57-31.77-19.69-89.47-24.85-126.07-26.57-10.15-.48-20.47-1.19-30.62-.66,1.09-5.52,.72-11.38,1.52-16.98,.9-6.35,2.07-12.67,2.75-19.05,2.8-26.14,3.51-53.36,4.68-79.66,.9-20.4,2.33-40.85,2.64-61.26"/>
        <path id="path164" class="cls-6" d="M69.06,704.49c13.1,12.42,28.93,20.94,45.24,28.34,41.55,18.85,81.04,27.13,126.54,29.43-.28,14.35,1.46,139.53-.33,142.43-1.16,.77-2.14,.74-3.49,.84-16.07-.44-32.09-1.64-48.05-3.59-20.7-2.52-76.1-10.15-89.08-26.72,1.01-5.56-12.55-70.39-14.49-80.85l-16.34-89.9"/>
        <path id="path166" class="cls-12" d="M90.59,296.25c5.8-1.96,11.84-3.38,17.76-4.98,1.38,3.78,4.44,8.79,8.1,10.84l.83-.24c.34-1.35,.7-2.69,1.09-4.02l.43,.03,1.13,6.75c9.63,5.37,25.57,9.28,36.5,13.64,24.12,9.87,47.92,20.44,71.42,31.7,22.74,10.91,45.57,22.14,67.95,33.78,27.08,14.1,53.84,28.67,81.02,42.6,8.49,4.35,19.94,12.39,29.1,13.82l-.15,8.52c-10.2-.66-20.53-2.88-30.68-4.28-13.75-1.89-27.55-3.02-41.38-4.13-78.24-6.29-158.87-5.06-236.36,7.82-.95-14.85-1.1-29.84-1.66-44.71-1.18-35.74-2.88-71.45-5.09-107.14"/>
        <path id="path168" class="cls-6" d="M439.25,699.52c-3.65,25.56-9.8,50.96-14.98,76.26-4.76,23.22-8.63,46.56-13.05,69.84-1.43,7.55-7.39,28.28-7.36,34.05-26.94,20.39-86.6,23.58-119.91,25.7-7.6,.48-19.85-.59-26.48,.92,1.68-5.41,.22-55.36,.16-65.81-.13-26.08,.48-52.24-.08-78.31,.49,.06,.56,.08,1.13,.1,8.83,.28,18.01-1.02,26.82-1.8,42.84-3.82,91.61-16.63,128-40.24,9.24-5.99,17.67-13.24,25.74-20.71"/>
        <path id="path170" class="cls-9" d="M108.34,291.27c10.22-2.68,20.44-5.38,30.83-7.33,81.5-15.29,194.08-13.75,273.34,11.68-.76,20.45-2.78,41-3.96,61.45-1.36,27.69-2.24,55.38-2.65,83.1-9.17-1.43-20.61-9.47-29.1-13.82-27.18-13.92-53.94-28.5-81.02-42.6-22.38-11.65-45.2-22.88-67.95-33.78-23.5-11.26-47.3-21.83-71.42-31.7-10.93-4.36-26.87-8.27-36.5-13.64l-1.13-6.75-.43-.03c-.4,1.33-.76,2.67-1.09,4.02l-.83,.24c-3.66-2.05-6.72-7.06-8.1-10.84"/>
        <path id="path172" class="cls-22" d="M122.59,449.71c17.1-1.9,34.24-3.41,51.4-4.54,17.17-1.12,34.36-1.85,51.56-2.19,17.2-.34,34.4-.29,51.6,.15,17.2,.44,34.38,1.28,51.54,2.5-.29,19.89-.84,39.82-.42,59.72,1.12,52.52,7.65,132.97,29.13,180.42,5.59,12.34,13.69,25.03,23.13,34.79,.38,.4,.78,.78,1.19,1.16l.06,.21c-6.79,2.49-14.41,4.04-21.42,5.89-45.76,12.09-93.36,15.98-140.23,8.41-32.83-5.3-71.5-16.56-91.67-44.81-29.97-41.97-16.99-106.59-13.53-154.59,1.34-19.66,2.92-39.3,4.74-58.92,.86-9.34,1.35-18.97,2.92-28.21"/>
      </g>
    </g>
  </g>
</svg>
  `;

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new window.google.maps.Size(50, 50), // Marker size
    anchor: new window.google.maps.Point(150, 150), // Center the anchor (half of width and height)
  };
};

const Satelite = () => (
  <svg
    fill="#000000"
    height="30px"
    width="30px"
    id="Icons"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
    xmlSpace="preserve"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <g>
        <path d="M12,16c-0.4,0-0.7-0.2-0.9-0.5l-6-10C4.9,5.1,5,4.6,5.3,4.3C5.6,4,6.1,3.9,6.5,4.1l10,6c0.3,0.2,0.5,0.5,0.5,0.9 C17,13.8,14.8,16,12,16z" />
      </g>
      <path d="M25.8,24.5c-3.1,3-7.2,4.7-11.5,4.7c-0.8,0-1.5-0.1-2.2-0.2c0,0.3-0.1,0.7-0.1,1c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1 C28,27.9,27.2,25.9,25.8,24.5z" />
      <path d="M24.5,2.4C22-0.1,16,1.9,10.3,7.3c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0c5-4.7,10-6.4,11.4-4.9c1.5,1.5-0.5,7-5.6,12.1 C12.5,21,7,23,5.5,21.5c-1.3-1.3-0.1-5.8,4.3-10.8c0.4-0.4,0.3-1-0.1-1.4C9.3,8.9,8.6,9,8.3,9.4c-4.9,5.5-6.7,11.1-4.2,13.5 c2.7,2.7,6.4,4.2,10.2,4.2s7.5-1.5,10.2-4.2C30.2,17.2,30.2,8.1,24.5,2.4z" />
    </g>
  </svg>
);

const RoadMap = () => (
  <svg
    fill="#000000"
    height="30px"
    width="30px"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 396 396"
    xmlSpace="preserve"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <g>
        <path d="M350.31,148.038c8.462-24.927,8.463-35.665,8.463-41.521C358.773,47.783,310.99,0,252.258,0 c-58.732,0-106.514,47.783-106.514,106.518c0,5.305,0,14.024,5.681,32.861l-13.159,5.033l-76.53-39.509 c-2.451-1.264-5.203-1.932-7.961-1.932c-3.187,0-6.309,0.875-9.032,2.531c-5.135,3.131-8.325,8.812-8.325,14.824v215.245 c0,6.522,3.6,12.433,9.396,15.424l83.432,43.068c4.339,2.242,9.597,2.536,14.165,0.792l105.737-40.445l85.743,39.962 c2.314,1.079,4.781,1.627,7.335,1.627c3.316,0,6.543-0.941,9.33-2.721c5.026-3.205,8.027-8.677,8.027-14.637V163.4 C359.582,156.959,355.971,151.02,350.31,148.038z M298.043,203.691c-16.811,34.811-33.186,64.178-33.352,64.474 c-2.482,4.455-7.191,7.223-12.293,7.223c-5.099,0-9.808-2.768-12.289-7.226c-0.164-0.294-16.605-29.781-33.354-64.471 c-34.371-71.193-34.371-90.748-34.371-97.174c0-44.119,35.894-80.013,80.014-80.013s80.014,35.894,80.014,80.013 C332.412,112.943,332.412,132.498,298.043,203.691z" />
        <path d="M252.398,70.112c-23.112,0-41.916,18.803-41.916,41.915c0,23.114,18.804,41.919,41.916,41.919 c23.111,0,41.914-18.805,41.914-41.919C294.313,88.915,275.51,70.112,252.398,70.112z" />
      </g>
    </g>
  </svg>
);

const SadIcon = () => (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 1024 1024"
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <path
        d="M512.004 512.002m-491.988 0a491.988 491.988 0 1 0 983.976 0 491.988 491.988 0 1 0-983.976 0Z"
        fill="#FDDF6D"
      />
      <path
        d="M617.43 931.354c-271.716 0-491.986-220.268-491.986-491.986 0-145.168 62.886-275.632 162.888-365.684C129.056 155.124 20.016 320.824 20.016 512c0 271.716 220.268 491.986 491.986 491.986 126.548 0 241.924-47.796 329.098-126.298-67.106 34.308-143.124 53.666-223.67 53.666z"
        fill="#FCC56B"
      />
      <path
        d="M735.828 834.472H496.912c-11.056 0-20.014-8.958-20.014-20.014s8.958-20.014 20.014-20.014h238.914c11.056 0 20.014 8.958 20.014 20.014s-8.956 20.014-20.012 20.014zM442.172 628.498c-48.674 0-92.65-12.454-117.634-33.316-8.486-7.082-9.62-19.706-2.536-28.188 7.082-8.484 19.702-9.62 28.188-2.536 17.472 14.586 53.576 24.012 91.98 24.012 37.486 0 74.086-9.604 93.242-24.464 8.732-6.776 21.3-5.188 28.08 3.546 6.776 8.732 5.188 21.304-3.546 28.08-26.524 20.58-70.554 32.866-117.774 32.866zM789.346 628.498c-48.674 0-92.65-12.454-117.634-33.316-8.486-7.082-9.62-19.706-2.536-28.188s19.706-9.62 28.188-2.536c17.472 14.586 53.576 24.012 91.98 24.012 37.486 0 74.086-9.604 93.242-24.464 8.73-6.776 21.304-5.188 28.08 3.546 6.776 8.732 5.188 21.304-3.546 28.08-26.526 20.58-70.554 32.866-117.774 32.866zM347.382 526.08c-7.438 0-14.36-0.836-20.53-2.544-10.654-2.946-16.9-13.972-13.954-24.628 2.948-10.654 13.984-16.904 24.628-13.954 9.852 2.73 30.072 0.814 53.044-9.608 22.486-10.194 37.75-24.62 42.904-34.39 5.156-9.78 17.26-13.528 27.038-8.368 9.778 5.156 13.524 17.264 8.368 27.038-10.488 19.886-33.582 39.392-61.778 52.178-20.608 9.346-41.672 14.276-59.72 14.276zM878.98 526.08c-18.05 0-39.108-4.928-59.724-14.278-28.194-12.782-51.288-32.288-61.774-52.174-5.158-9.776-1.41-21.882 8.368-27.038 9.778-5.164 21.882-1.406 27.038 8.368 5.156 9.77 20.418 24.194 42.898 34.388 22.974 10.42 43.2 12.338 53.044 9.61 10.666-2.938 21.68 3.298 24.628 13.952 2.946 10.654-3.298 21.68-13.952 24.628-6.166 1.706-13.09 2.544-20.526 2.544z"
        fill="#7F184C"
      />
      <path
        d="M711.124 40.168c-10.176-4.304-21.922 0.464-26.224 10.646s0.464 21.926 10.646 26.224c175.212 74.03 288.428 244.764 288.428 434.96 0 260.248-211.724 471.97-471.968 471.97S40.03 772.244 40.03 511.998 251.756 40.03 512.002 40.03c11.056 0 20.014-8.958 20.014-20.014S523.058 0 512.002 0c-282.32 0-512 229.68-512 511.998 0 282.32 229.68 512.002 512 512.002C794.318 1024 1024 794.32 1024 512c0.002-206.322-122.812-391.528-312.876-471.832z"
        fill=""
      />
      <path
        d="M496.912 794.444c-11.056 0-20.014 8.958-20.014 20.014s8.958 20.014 20.014 20.014h238.914c11.056 0 20.014-8.958 20.014-20.014s-8.958-20.014-20.014-20.014H496.912zM350.194 564.46c-8.488-7.088-21.106-5.948-28.188 2.536-7.086 8.486-5.948 21.106 2.536 28.188 24.984 20.86 68.96 33.316 117.634 33.316 47.218 0 91.248-12.286 117.778-32.864 8.734-6.776 10.322-19.348 3.546-28.08-6.778-8.738-19.348-10.32-28.08-3.546-19.158 14.858-55.758 24.464-93.242 24.464-38.408-0.002-74.514-9.43-91.984-24.014zM671.714 595.184c24.984 20.86 68.96 33.316 117.634 33.316 47.218 0 91.248-12.286 117.778-32.864 8.734-6.776 10.322-19.348 3.546-28.08-6.776-8.738-19.35-10.32-28.08-3.546-19.158 14.858-55.758 24.464-93.242 24.464-38.404 0-74.508-9.426-91.98-24.012-8.486-7.088-21.104-5.948-28.188 2.536-7.09 8.48-5.954 21.104 2.532 28.186zM347.382 526.08c18.048 0 39.108-4.926 59.718-14.272 28.196-12.786 51.294-32.29 61.778-52.176 5.158-9.776 1.41-21.882-8.368-27.038-9.778-5.164-21.882-1.41-27.038 8.368-5.156 9.77-20.418 24.194-42.904 34.388-22.972 10.42-43.19 12.34-53.042 9.608-10.646-2.936-21.68 3.298-24.628 13.952-2.946 10.65 3.296 21.68 13.952 24.628 6.17 1.704 13.094 2.542 20.532 2.542zM819.26 511.808c20.616 9.346 41.674 14.272 59.722 14.272 7.434 0 14.362-0.836 20.532-2.546 10.65-2.948 16.896-13.976 13.946-24.628a20.004 20.004 0 0 0-24.628-13.946c-9.842 2.714-30.062 0.812-53.042-9.61-22.48-10.192-37.746-24.618-42.898-34.388-5.156-9.778-17.26-13.53-27.038-8.368-9.778 5.156-13.524 17.264-8.368 27.038 10.482 19.888 33.576 39.39 61.774 52.176z"
        fill=""
      />
      <path
        d="M638.204 37.682m-20.014 0a20.014 20.014 0 1 0 40.028 0 20.014 20.014 0 1 0-40.028 0Z"
        fill=""
      />
    </g>
  </svg>
);

const ShowFilterIcon = () => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth={0} />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path
          d="M15 15L21 21M21 15L15 21M10 21V14.6627C10 14.4182 10 14.2959 9.97237 14.1808C9.94787 14.0787 9.90747 13.9812 9.85264 13.8917C9.7908 13.7908 9.70432 13.7043 9.53137 13.5314L3.46863 7.46863C3.29568 7.29568 3.2092 7.2092 3.14736 7.10828C3.09253 7.01881 3.05213 6.92127 3.02763 6.81923C3 6.70414 3 6.58185 3 6.33726V4.6C3 4.03995 3 3.75992 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.75992 3 4.03995 3 4.6 3H19.4C19.9601 3 20.2401 3 20.454 3.10899C20.6422 3.20487 20.7951 3.35785 20.891 3.54601C21 3.75992 21 4.03995 21 4.6V6.33726C21 6.58185 21 6.70414 20.9724 6.81923C20.9479 6.92127 20.9075 7.01881 20.8526 7.10828C20.7908 7.2092 20.7043 7.29568 20.5314 7.46863L17 11"
          stroke="#000000"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

const HideFilterIcon = () => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth={0} />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path
          d="M3 4.6C3 4.03995 3 3.75992 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.75992 3 4.03995 3 4.6 3H19.4C19.9601 3 20.2401 3 20.454 3.10899C20.6422 3.20487 20.7951 3.35785 20.891 3.54601C21 3.75992 21 4.03995 21 4.6V6.33726C21 6.58185 21 6.70414 20.9724 6.81923C20.9479 6.92127 20.9075 7.01881 20.8526 7.10828C20.7908 7.2092 20.7043 7.29568 20.5314 7.46863L14.4686 13.5314C14.2957 13.7043 14.2092 13.7908 14.1474 13.8917C14.0925 13.9812 14.0521 14.0787 14.0276 14.1808C14 14.2959 14 14.4182 14 14.6627V17L10 21V14.6627C10 14.4182 10 14.2959 9.97237 14.1808C9.94787 14.0787 9.90747 13.9812 9.85264 13.8917C9.7908 13.7908 9.70432 13.7043 9.53137 13.5314L3.46863 7.46863C3.29568 7.29568 3.2092 7.2092 3.14736 7.10828C3.09253 7.01881 3.05213 6.92127 3.02763 6.81923C3 6.70414 3 6.58185 3 6.33726V4.6Z"
          stroke="#000000"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

const HideDetailsIcon = (props) => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth={0} />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 16H13L10.8368 13.3376C9.96488 13.7682 8.99592 14 8 14C6.09909 14 4.29638 13.1557 3.07945 11.6953L0 8L3.07945 4.30466C3.14989 4.22013 3.22229 4.13767 3.29656 4.05731L0 0H3L16 16ZM5.35254 6.58774C5.12755 7.00862 5 7.48941 5 8C5 9.65685 6.34315 11 8 11C8.29178 11 8.57383 10.9583 8.84053 10.8807L5.35254 6.58774Z"
          fill="#000000"
        />
        <path
          d="M16 8L14.2278 10.1266L7.63351 2.01048C7.75518 2.00351 7.87739 2 8 2C9.90091 2 11.7036 2.84434 12.9206 4.30466L16 8Z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};

const ShowDetailsIcon = (props) => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth={0} />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8L3.07945 4.30466C4.29638 2.84434 6.09909 2 8 2C9.90091 2 11.7036 2.84434 12.9206 4.30466L16 8L12.9206 11.6953C11.7036 13.1557 9.90091 14 8 14C6.09909 14 4.29638 13.1557 3.07945 11.6953L0 8ZM8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};

const MapRecenter = () => {
  return (
    <svg
      fill="#000000"
      height="30px"
      width="30px"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 492.589 492.589"
      xmlSpace="preserve"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth={0} />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M468.467,222.168h-28.329c-9.712-89.679-80.46-161.18-169.71-172.258V24.135c0-13.338-10.791-24.134-24.134-24.134 c-13.311,0-24.117,10.796-24.117,24.134V49.91C132.924,60.988,62.177,132.488,52.482,222.168H24.153 C10.806,222.168,0,232.964,0,246.286c0,13.336,10.806,24.132,24.153,24.132h29.228c12.192,86.816,81.551,155.4,168.797,166.229 v31.804c0,13.336,10.806,24.135,24.117,24.135c13.343,0,24.134-10.799,24.134-24.135v-31.804 c87.228-10.829,156.607-79.413,168.775-166.229h29.264c13.33,0,24.122-10.796,24.122-24.132 C492.589,232.964,481.797,222.168,468.467,222.168z M246.294,398.093c-85.345,0-154.804-69.453-154.804-154.813 c0-85.363,69.459-154.813,154.804-154.813c85.376,0,154.823,69.45,154.823,154.813 C401.117,328.639,331.671,398.093,246.294,398.093z" />
          <path d="M246.294,176.93c-36.628,0-66.34,29.704-66.34,66.349c0,36.635,29.711,66.349,66.34,66.349 c36.66,0,66.34-29.713,66.34-66.349C312.634,206.635,282.955,176.93,246.294,176.93z" />
        </g>
      </g>
    </svg>
  );
};

const DrawIcon = (size = "30px", color = "#000000") => {
  return (
    <svg
      fill={color}
      height={size}
      width={size}
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M392.26 1042.5c137.747-57.67 292.85-15.269 425.873 116.217l4.394 4.833c116.656 146.425 149.5 279.119 97.873 394.237-128.85 287.138-740.692 328.77-810.005 332.504L0 1896.442l61.953-91.83c.989-1.539 105.013-158.728 105.013-427.192 0-141.811 92.6-279.558 225.294-334.92ZM1728.701 23.052c54.923-1.099 99.96 15.268 135.111 49.43 40.643 40.644 58.109 87.877 56.021 140.603C1908.85 474.52 1423.33 953.447 1053.15 1280.79c-24.276-64.81-63.711-136.21-125.335-213.102l-8.787-9.886c-80.078-80.187-169.163-135.11-262.423-161.473C955.276 558.002 1460.677 33.927 1728.701 23.052Z"
          fillRule="evenodd"
        ></path>{" "}
      </g>
    </svg>
  );
};

const DrawIconDisable = () => {
  return (
    <svg
      fill="#000000"
      height="30px"
      width="30px"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M517.257 1127.343c72.733 0 148.871 36.586 221.274 107.45 87.455 110.418 114.922 204.135 81.632 278.296-72.733 162.274-412.664 234.897-618.666 259.178 34.609-82.62 75.15-216.88 75.15-394.645 0-97.123 66.47-195.455 157.88-233.689 26.698-11.097 54.494-16.59 82.73-16.59Zm229.404-167.109c54.055 28.895 106.462 65.371 155.133 113.494l13.844 15.6c28.016 35.378 50.649 69.987 70.425 104.155-29.554 26.259-59.878 52.737-90.75 79.545-18.898-35.488-43.069-71.964-72.843-109.319l-4.285-4.834c-48.342-47.683-99.43-83.39-151.727-107.011 26.368-30.653 53.066-61.196 80.203-91.63Zm1046.49-803.133c7.801 7.8 18.129 21.754 16.92 52.187-6.043 155.683-284.338 494.405-740.509 909.266-19.995-32.302-41.969-64.822-67.788-97.453l-22.523-25.27c-49.22-48.671-101.408-88.883-156.012-121.074 350.588-385.855 728.203-734.356 910.254-741.828 30.983-.109 44.497 9.01 59.658 24.172Zm126.678 56.472c2.087-53.615-14.832-99.98-56.142-141.29-34.28-34.279-81.962-51.198-134.588-49.11-304.554 12.414-912.232 683.377-1179.54 996.17-53.616-5.383-106.682 2.088-157.441 23.402-132.61 55.263-225.339 193.038-225.339 334.877 0 268.517-103.935 425.737-104.923 427.275L0 1896.747l110.307-6.153c69.217-3.735 681.29-45.375 810.165-332.46 24.39-54.604 29.225-113.163 15.93-175.239 374.32-321.802 972.11-879.71 983.427-1169.322"
          fillRule="evenodd"
        ></path>{" "}
      </g>
    </svg>
  );
};

const TrashIcon = (size = "30px", color = "#000000") => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color}
      d="M2.75 6.16667C2.75 5.70644 3.09538 5.33335 3.52143 5.33335L6.18567 5.3329C6.71502 5.31841 7.18202 4.95482 7.36214 4.41691C7.36688 4.40277 7.37232 4.38532 7.39185 4.32203L7.50665 3.94993C7.5769 3.72179 7.6381 3.52303 7.72375 3.34536C8.06209 2.64349 8.68808 2.1561 9.41147 2.03132C9.59457 1.99973 9.78848 1.99987 10.0111 2.00002H13.4891C13.7117 1.99987 13.9056 1.99973 14.0887 2.03132C14.8121 2.1561 15.4381 2.64349 15.7764 3.34536C15.8621 3.52303 15.9233 3.72179 15.9935 3.94993L16.1083 4.32203C16.1279 4.38532 16.1333 4.40277 16.138 4.41691C16.3182 4.95482 16.8778 5.31886 17.4071 5.33335H19.9786C20.4046 5.33335 20.75 5.70644 20.75 6.16667C20.75 6.62691 20.4046 7 19.9786 7H3.52143C3.09538 7 2.75 6.62691 2.75 6.16667Z"
    />
    <path
      fill={color}
      d="M11.6068 21.9998H12.3937C15.1012 21.9998 16.4549 21.9998 17.3351 21.1366C18.2153 20.2734 18.3054 18.8575 18.4855 16.0256L18.745 11.945C18.8427 10.4085 18.8916 9.6402 18.45 9.15335C18.0084 8.6665 17.2628 8.6665 15.7714 8.6665H8.22905C6.73771 8.6665 5.99204 8.6665 5.55047 9.15335C5.10891 9.6402 5.15777 10.4085 5.25549 11.945L5.515 16.0256C5.6951 18.8575 5.78515 20.2734 6.66534 21.1366C7.54553 21.9998 8.89927 21.9998 11.6068 21.9998Z"
    />
  </svg>
);

const FocusIcon = (size = "25px", color = "#000000") => {
  return (
    <svg
      viewBox="0 0 20 20"
      version="1.1"
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill={color}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <title>focus_point [#847]</title>
        <desc>Created with Sketch.</desc>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Dribbble-Light-Preview"
            transform="translate(-180.000000, -4439.000000)"
            fill={color}
          >
            <g id="icons" transform="translate(56.000000, 160.000000)">
              <path
                d="M136,4290.0016 L136,4287.9986 C136,4287.4466 135.553,4286.9996 135.002,4286.9996 L132.998,4286.9996 C132.447,4286.9996 132,4287.4466 132,4287.9986 L132,4290.0016 C132,4290.5526 132.447,4290.9996 132.998,4290.9996 L135.002,4290.9996 C135.553,4290.9996 136,4290.5526 136,4290.0016 Z M136,4292.9996 L135,4292.9996 L135,4293.9996 C135,4294.5526 134.552,4294.9996 134,4294.9996 C133.448,4294.9996 133,4294.5526 133,4293.9996 L133,4292.9996 L132,4292.9996 C130.895,4292.9996 130,4292.1046 130,4290.9996 L130,4289.9996 L129,4289.9996 C128.448,4289.9996 128,4289.5526 128,4288.9996 C128,4288.4476 128.448,4287.9996 129,4287.9996 L130,4287.9996 L130,4286.9996 C130,4285.8956 130.895,4284.9996 132,4284.9996 L133,4284.9996 L133,4283.9996 C133,4283.4476 133.448,4282.9996 134,4282.9996 C134.552,4282.9996 135,4283.4476 135,4283.9996 L135,4284.9996 L136,4284.9996 C137.105,4284.9996 138,4285.8956 138,4286.9996 L138,4287.9996 L139,4287.9996 C139.552,4287.9996 140,4288.4476 140,4288.9996 C140,4289.5526 139.552,4289.9996 139,4289.9996 L138,4289.9996 L138,4290.9996 C138,4292.1046 137.105,4292.9996 136,4292.9996 Z M142,4278.9996 L137,4278.9996 C136.448,4278.9996 136,4279.4476 136,4279.9996 C136,4280.5526 136.448,4280.9996 137,4280.9996 L141,4280.9996 C141.552,4280.9996 142,4281.4476 142,4281.9996 L142,4285.9996 C142,4286.5526 142.448,4286.9996 143,4286.9996 C143.552,4286.9996 144,4286.5526 144,4285.9996 L144,4280.9996 C144,4279.8956 143.105,4278.9996 142,4278.9996 Z M143,4290.9996 C142.448,4290.9996 142,4291.4476 142,4291.9996 L142,4295.9996 C142,4296.5526 141.552,4296.9996 141,4296.9996 L137,4296.9996 C136.448,4296.9996 136,4297.4476 136,4297.9996 C136,4298.5526 136.448,4298.9996 137,4298.9996 L142,4298.9996 C143.105,4298.9996 144,4298.1046 144,4296.9996 L144,4291.9996 C144,4291.4476 143.552,4290.9996 143,4290.9996 Z M131,4296.9996 L127,4296.9996 C126.448,4296.9996 126,4296.5526 126,4295.9996 L126,4291.9996 C126,4291.4476 125.552,4290.9996 125,4290.9996 C124.448,4290.9996 124,4291.4476 124,4291.9996 L124,4296.9996 C124,4298.1046 124.895,4298.9996 126,4298.9996 L131,4298.9996 C131.552,4298.9996 132,4298.5526 132,4297.9996 C132,4297.4476 131.552,4296.9996 131,4296.9996 Z M125,4286.9996 C125.552,4286.9996 126,4286.5526 126,4285.9996 L126,4281.9996 C126,4281.4476 126.448,4280.9996 127,4280.9996 L131,4280.9996 C131.552,4280.9996 132,4280.5526 132,4279.9996 C132,4279.4476 131.552,4278.9996 131,4278.9996 L126,4278.9996 C124.895,4278.9996 124,4279.8956 124,4280.9996 L124,4285.9996 C124,4286.5526 124.448,4286.9996 125,4286.9996 Z M124.01,4288.9996 L124,4289.0096 L124,4288.9906 L124.01,4288.9996 Z"
                id="focus_point-[#847]"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const HideCarIcon = () => {
  return (
    <svg
      fill="#000000"
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth={0} />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path d="M7,13a1,1,0,1,0,1,1A1,1,0,0,0,7,13ZM19.76,9.11,18.41,5.05a3,3,0,0,0-2.85-2H9.66a1,1,0,0,0,0,2h5.9a1,1,0,0,1,1,.69L17.61,9H15.66a1,1,0,0,0,0,2H19a1,1,0,0,1,1,1v3.34a1,1,0,1,0,2,0V12A3,3,0,0,0,19.76,9.11Zm-16-6.82A1,1,0,0,0,2.29,3.71L5.11,6.52,4.24,9.11A3,3,0,0,0,2,12v4a3,3,0,0,0,2,2.82V20a1,1,0,0,0,2,0V19H17.59l.41.41V20a1,1,0,0,0,1,1,.91.91,0,0,0,.46-.13l.83.84a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Zm3,5.81.9.9H6.39ZM5,17a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H9.59l2,2H11a1,1,0,0,0,0,2h2a.91.91,0,0,0,.46-.13L15.59,17Z" />
      </g>
    </svg>
  );
};

const ShowCarIcon = () => {
  return (
    <svg
      fill="#000000"
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth={0} />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path d="M6.62,13.08a.9.9,0,0,0-.54.54,1,1,0,0,0,1.3,1.3,1.15,1.15,0,0,0,.33-.21,1.15,1.15,0,0,0,.21-.33A.84.84,0,0,0,8,14a1.05,1.05,0,0,0-.29-.71A1,1,0,0,0,6.62,13.08Zm13.14-4L18.4,5.05a3,3,0,0,0-2.84-2H8.44A3,3,0,0,0,5.6,5.05L4.24,9.11A3,3,0,0,0,2,12v4a3,3,0,0,0,2,2.82V20a1,1,0,0,0,2,0V19H18v1a1,1,0,0,0,2,0V18.82A3,3,0,0,0,22,16V12A3,3,0,0,0,19.76,9.11ZM7.49,5.68A1,1,0,0,1,8.44,5h7.12a1,1,0,0,1,1,.68L17.61,9H6.39ZM20,16a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H19a1,1,0,0,1,1,1Zm-3.38-2.92a.9.9,0,0,0-.54.54,1,1,0,0,0,1.3,1.3.9.9,0,0,0,.54-.54A.84.84,0,0,0,18,14a1.05,1.05,0,0,0-.29-.71A1,1,0,0,0,16.62,13.08ZM13,13H11a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z" />
      </g>
    </svg>
  );
};

const Loader = () => (
  <svg
    width="50px"
    height="50px"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
  >
    <circle
      fill="#2c786c"
      stroke="#2c786c"
      strokeWidth={15}
      r={15}
      cx={40}
      cy={65}
    >
      <animate
        attributeName="cy"
        calcMode="spline"
        dur={2}
        values="65;135;65;"
        keySplines=".5 0 .5 1;.5 0 .5 1"
        repeatCount="indefinite"
        begin={-0.4}
      />
    </circle>
    <circle
      fill="#2c786c"
      stroke="#2c786c"
      strokeWidth={15}
      r={15}
      cx={100}
      cy={65}
    >
      <animate
        attributeName="cy"
        calcMode="spline"
        dur={2}
        values="65;135;65;"
        keySplines=".5 0 .5 1;.5 0 .5 1"
        repeatCount="indefinite"
        begin={-0.2}
      />
    </circle>
    <circle
      fill="#2c786c"
      stroke="#2c786c"
      strokeWidth={15}
      r={15}
      cx={160}
      cy={65}
    >
      <animate
        attributeName="cy"
        calcMode="spline"
        dur={2}
        values="65;135;65;"
        keySplines=".5 0 .5 1;.5 0 .5 1"
        repeatCount="indefinite"
        begin={0}
      />
    </circle>
  </svg>
);

export {
  getInTrailPoisSvg,
  getTeamNumberSvg,
  getLocationEnableDisableIcon,
  NotificationBellSvg,
  POIsSvg,
  getIsNeutralSvg,
  DirectionalCarSVG,
  ResultIconWithRank,
  Circle,
  RotatingOffRadar,
  RefreshIcon,
  CarMarker,
  NewCar,
  CrossIcon,
  OnTrailPowerOnOff,
  Satelite,
  RoadMap,
  SadIcon,
  ShowFilterIcon,
  HideFilterIcon,
  ShowDetailsIcon,
  HideDetailsIcon,
  MapRecenter,
  HideCarIcon,
  ShowCarIcon,
  Loader,
  MarkerCircle,
  DrawIcon,
  DrawIconDisable,
  FocusIcon,
  TrashIcon,
};
